var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf,
  __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function () {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
    get: () => from[key],
    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
  });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: !0
}) : target, mod));
var require_ReactPropTypesSecret = __commonJS({
  "../../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";

    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});
var require_factoryWithThrowingShims = __commonJS({
  "../../../node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    "use strict";

    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function () {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret !== ReactPropTypesSecret) {
          var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw err.name = "Invariant Violation", err;
        }
      }
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
    };
  }
});
var require_prop_types = __commonJS({
  "../../../node_modules/prop-types/index.js"(exports, module) {
    module.exports = require_factoryWithThrowingShims()();
    var ReactIs, throwOnDirectAccess;
  }
});
var require_react_is_production_min = __commonJS({
  "../../../node_modules/downshift/node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";

    var b = 60103,
      c = 60106,
      d = 60107,
      e2 = 60108,
      f = 60114,
      g = 60109,
      h = 60110,
      k = 60112,
      l = 60113,
      m = 60120,
      n2 = 60115,
      p = 60116,
      q = 60121,
      r2 = 60122,
      u = 60117,
      v = 60129,
      w = 60131;
    typeof Symbol == "function" && Symbol.for && (x = Symbol.for, b = x("react.element"), c = x("react.portal"), d = x("react.fragment"), e2 = x("react.strict_mode"), f = x("react.profiler"), g = x("react.provider"), h = x("react.context"), k = x("react.forward_ref"), l = x("react.suspense"), m = x("react.suspense_list"), n2 = x("react.memo"), p = x("react.lazy"), q = x("react.block"), r2 = x("react.server.block"), u = x("react.fundamental"), v = x("react.debug_trace_mode"), w = x("react.legacy_hidden"));
    var x;
    function y(a) {
      if (typeof a == "object" && a !== null) {
        var t2 = a.$$typeof;
        switch (t2) {
          case b:
            switch (a = a.type, a) {
              case d:
              case f:
              case e2:
              case l:
              case m:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case h:
                  case k:
                  case p:
                  case n2:
                  case g:
                    return a;
                  default:
                    return t2;
                }
            }
          case c:
            return t2;
        }
      }
    }
    var z = g,
      A = b,
      B = k,
      C = d,
      D = p,
      E = n2,
      F = c,
      G = f,
      H = e2,
      I = l;
    exports.ContextConsumer = h;
    exports.ContextProvider = z;
    exports.Element = A;
    exports.ForwardRef = B;
    exports.Fragment = C;
    exports.Lazy = D;
    exports.Memo = E;
    exports.Portal = F;
    exports.Profiler = G;
    exports.StrictMode = H;
    exports.Suspense = I;
    exports.isAsyncMode = function () {
      return !1;
    };
    exports.isConcurrentMode = function () {
      return !1;
    };
    exports.isContextConsumer = function (a) {
      return y(a) === h;
    };
    exports.isContextProvider = function (a) {
      return y(a) === g;
    };
    exports.isElement = function (a) {
      return typeof a == "object" && a !== null && a.$$typeof === b;
    };
    exports.isForwardRef = function (a) {
      return y(a) === k;
    };
    exports.isFragment = function (a) {
      return y(a) === d;
    };
    exports.isLazy = function (a) {
      return y(a) === p;
    };
    exports.isMemo = function (a) {
      return y(a) === n2;
    };
    exports.isPortal = function (a) {
      return y(a) === c;
    };
    exports.isProfiler = function (a) {
      return y(a) === f;
    };
    exports.isStrictMode = function (a) {
      return y(a) === e2;
    };
    exports.isSuspense = function (a) {
      return y(a) === l;
    };
    exports.isValidElementType = function (a) {
      return typeof a == "string" || typeof a == "function" || a === d || a === f || a === v || a === e2 || a === l || a === m || a === w || typeof a == "object" && a !== null && (a.$$typeof === p || a.$$typeof === n2 || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r2);
    };
    exports.typeOf = y;
  }
});
var require_react_is = __commonJS({
  "../../../node_modules/downshift/node_modules/react-is/index.js"(exports, module) {
    "use strict";

    module.exports = require_react_is_production_min();
  }
});
var require_tslib = __commonJS({
  "../../../node_modules/tslib/tslib.js"(exports, module) {
    var __extends2, __assign2, __rest2, __decorate2, __param2, __metadata2, __awaiter2, __generator2, __exportStar2, __values2, __read2, __spread2, __spreadArrays2, __spreadArray2, __await2, __asyncGenerator2, __asyncDelegator2, __asyncValues2, __makeTemplateObject2, __importStar2, __importDefault2, __classPrivateFieldGet2, __classPrivateFieldSet2, __createBinding2;
    (function (factory) {
      var root = typeof global == "object" ? global : typeof self == "object" ? self : typeof this == "object" ? this : {};
      typeof define == "function" && define.amd ? define("tslib", ["exports"], function (exports2) {
        factory(createExporter(root, createExporter(exports2)));
      }) : typeof module == "object" && typeof module.exports == "object" ? factory(createExporter(root, createExporter(module.exports))) : factory(createExporter(root));
      function createExporter(exports2, previous) {
        return exports2 !== root && (typeof Object.create == "function" ? Object.defineProperty(exports2, "__esModule", {
          value: !0
        }) : exports2.__esModule = !0), function (id, v) {
          return exports2[id] = previous ? previous(id, v) : v;
        };
      }
    })(function (exporter) {
      var extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) Object.prototype.hasOwnProperty.call(b, p) && (d[p] = b[p]);
      };
      __extends2 = function (d, b) {
        if (typeof b != "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      }, __assign2 = Object.assign || function (t2) {
        for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
          s = arguments[i];
          for (var p in s) Object.prototype.hasOwnProperty.call(s, p) && (t2[p] = s[p]);
        }
        return t2;
      }, __rest2 = function (s, e2) {
        var t2 = {};
        for (var p in s) Object.prototype.hasOwnProperty.call(s, p) && e2.indexOf(p) < 0 && (t2[p] = s[p]);
        if (s != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]) && (t2[p[i]] = s[p[i]]);
        return t2;
      }, __decorate2 = function (decorators, target, key, desc) {
        var c = arguments.length,
          r2 = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect == "object" && typeof Reflect.decorate == "function") r2 = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) (d = decorators[i]) && (r2 = (c < 3 ? d(r2) : c > 3 ? d(target, key, r2) : d(target, key)) || r2);
        return c > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      }, __param2 = function (paramIndex, decorator) {
        return function (target, key) {
          decorator(target, key, paramIndex);
        };
      }, __metadata2 = function (metadataKey, metadataValue) {
        if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(metadataKey, metadataValue);
      }, __awaiter2 = function (thisArg, _arguments, P, generator) {
        function adopt(value) {
          return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
          });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e2) {
              reject(e2);
            }
          }
          function rejected(value) {
            try {
              step(generator.throw(value));
            } catch (e2) {
              reject(e2);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      }, __generator2 = function (thisArg, body) {
        var _ = {
            label: 0,
            sent: function () {
              if (t2[0] & 1) throw t2[1];
              return t2[1];
            },
            trys: [],
            ops: []
          },
          f,
          y,
          t2,
          g;
        return g = {
          next: verb(0),
          throw: verb(1),
          return: verb(2)
        }, typeof Symbol == "function" && (g[Symbol.iterator] = function () {
          return this;
        }), g;
        function verb(n2) {
          return function (v) {
            return step([n2, v]);
          };
        }
        function step(op) {
          if (f) throw new TypeError("Generator is already executing.");
          for (; _;) try {
            if (f = 1, y && (t2 = op[0] & 2 ? y.return : op[0] ? y.throw || ((t2 = y.return) && t2.call(y), 0) : y.next) && !(t2 = t2.call(y, op[1])).done) return t2;
            switch (y = 0, t2 && (op = [op[0] & 2, t2.value]), op[0]) {
              case 0:
              case 1:
                t2 = op;
                break;
              case 4:
                return _.label++, {
                  value: op[1],
                  done: !1
                };
              case 5:
                _.label++, y = op[1], op = [0];
                continue;
              case 7:
                op = _.ops.pop(), _.trys.pop();
                continue;
              default:
                if (t2 = _.trys, !(t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _ = 0;
                  continue;
                }
                if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                  _.label = op[1];
                  break;
                }
                if (op[0] === 6 && _.label < t2[1]) {
                  _.label = t2[1], t2 = op;
                  break;
                }
                if (t2 && _.label < t2[2]) {
                  _.label = t2[2], _.ops.push(op);
                  break;
                }
                t2[2] && _.ops.pop(), _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
          } catch (e2) {
            op = [6, e2], y = 0;
          } finally {
            f = t2 = 0;
          }
          if (op[0] & 5) throw op[1];
          return {
            value: op[0] ? op[1] : void 0,
            done: !0
          };
        }
      }, __exportStar2 = function (m, o) {
        for (var p in m) p !== "default" && !Object.prototype.hasOwnProperty.call(o, p) && __createBinding2(o, m, p);
      }, __createBinding2 = Object.create ? function (o, m, k, k2) {
        k2 === void 0 && (k2 = k), Object.defineProperty(o, k2, {
          enumerable: !0,
          get: function () {
            return m[k];
          }
        });
      } : function (o, m, k, k2) {
        k2 === void 0 && (k2 = k), o[k2] = m[k];
      }, __values2 = function (o) {
        var s = typeof Symbol == "function" && Symbol.iterator,
          m = s && o[s],
          i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length == "number") return {
          next: function () {
            return o && i >= o.length && (o = void 0), {
              value: o && o[i++],
              done: !o
            };
          }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }, __read2 = function (o, n2) {
        var m = typeof Symbol == "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
          r2,
          ar = [],
          e2;
        try {
          for (; (n2 === void 0 || n2-- > 0) && !(r2 = i.next()).done;) ar.push(r2.value);
        } catch (error) {
          e2 = {
            error
          };
        } finally {
          try {
            r2 && !r2.done && (m = i.return) && m.call(i);
          } finally {
            if (e2) throw e2.error;
          }
        }
        return ar;
      }, __spread2 = function () {
        for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read2(arguments[i]));
        return ar;
      }, __spreadArrays2 = function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r2 = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r2[k] = a[j];
        return r2;
      }, __spreadArray2 = function (to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) (ar || !(i in from)) && (ar || (ar = Array.prototype.slice.call(from, 0, i)), ar[i] = from[i]);
        return to.concat(ar || Array.prototype.slice.call(from));
      }, __await2 = function (v) {
        return this instanceof __await2 ? (this.v = v, this) : new __await2(v);
      }, __asyncGenerator2 = function (thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []),
          i,
          q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
          return this;
        }, i;
        function verb(n2) {
          g[n2] && (i[n2] = function (v) {
            return new Promise(function (a, b) {
              q.push([n2, v, a, b]) > 1 || resume(n2, v);
            });
          });
        }
        function resume(n2, v) {
          try {
            step(g[n2](v));
          } catch (e2) {
            settle(q[0][3], e2);
          }
        }
        function step(r2) {
          r2.value instanceof __await2 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f, v) {
          f(v), q.shift(), q.length && resume(q[0][0], q[0][1]);
        }
      }, __asyncDelegator2 = function (o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e2) {
          throw e2;
        }), verb("return"), i[Symbol.iterator] = function () {
          return this;
        }, i;
        function verb(n2, f) {
          i[n2] = o[n2] ? function (v) {
            return (p = !p) ? {
              value: __await2(o[n2](v)),
              done: n2 === "return"
            } : f ? f(v) : v;
          } : f;
        }
      }, __asyncValues2 = function (o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator],
          i;
        return m ? m.call(o) : (o = typeof __values2 == "function" ? __values2(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
          return this;
        }, i);
        function verb(n2) {
          i[n2] = o[n2] && function (v) {
            return new Promise(function (resolve, reject) {
              v = o[n2](v), settle(resolve, reject, v.done, v.value);
            });
          };
        }
        function settle(resolve, reject, d, v) {
          Promise.resolve(v).then(function (v2) {
            resolve({
              value: v2,
              done: d
            });
          }, reject);
        }
      }, __makeTemplateObject2 = function (cooked, raw) {
        return Object.defineProperty ? Object.defineProperty(cooked, "raw", {
          value: raw
        }) : cooked.raw = raw, cooked;
      };
      var __setModuleDefault = Object.create ? function (o, v) {
        Object.defineProperty(o, "default", {
          enumerable: !0,
          value: v
        });
      } : function (o, v) {
        o.default = v;
      };
      __importStar2 = function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) k !== "default" && Object.prototype.hasOwnProperty.call(mod, k) && __createBinding2(result, mod, k);
        return __setModuleDefault(result, mod), result;
      }, __importDefault2 = function (mod) {
        return mod && mod.__esModule ? mod : {
          default: mod
        };
      }, __classPrivateFieldGet2 = function (receiver, state, kind, f) {
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
        if (typeof state == "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
      }, __classPrivateFieldSet2 = function (receiver, state, value, kind, f) {
        if (kind === "m") throw new TypeError("Private method is not writable");
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
        if (typeof state == "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
      }, exporter("__extends", __extends2), exporter("__assign", __assign2), exporter("__rest", __rest2), exporter("__decorate", __decorate2), exporter("__param", __param2), exporter("__metadata", __metadata2), exporter("__awaiter", __awaiter2), exporter("__generator", __generator2), exporter("__exportStar", __exportStar2), exporter("__createBinding", __createBinding2), exporter("__values", __values2), exporter("__read", __read2), exporter("__spread", __spread2), exporter("__spreadArrays", __spreadArrays2), exporter("__spreadArray", __spreadArray2), exporter("__await", __await2), exporter("__asyncGenerator", __asyncGenerator2), exporter("__asyncDelegator", __asyncDelegator2), exporter("__asyncValues", __asyncValues2), exporter("__makeTemplateObject", __makeTemplateObject2), exporter("__importStar", __importStar2), exporter("__importDefault", __importDefault2), exporter("__classPrivateFieldGet", __classPrivateFieldGet2), exporter("__classPrivateFieldSet", __classPrivateFieldSet2);
    });
  }
});
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {},
    sourceKeys = Object.keys(source),
    key,
    i;
  for (i = 0; i < sourceKeys.length; i++) key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (o2, p2) {
    return o2.__proto__ = p2, o2;
  }, _setPrototypeOf(o, p);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype), subClass.prototype.constructor = subClass, _setPrototypeOf(subClass, superClass);
}
var import_prop_types = __toESM(require_prop_types()),
  import_react_is = __toESM(require_react_is());
import { cloneElement, Component, useRef, useEffect, useCallback, useLayoutEffect, useReducer, useMemo } from "react";
function t(t2) {
  return typeof t2 == "object" && t2 != null && t2.nodeType === 1;
}
function e(t2, e2) {
  return (!e2 || t2 !== "hidden") && t2 !== "visible" && t2 !== "clip";
}
function n(t2, n2) {
  if (t2.clientHeight < t2.scrollHeight || t2.clientWidth < t2.scrollWidth) {
    var r2 = getComputedStyle(t2, null);
    return e(r2.overflowY, n2) || e(r2.overflowX, n2) || function (t3) {
      var e2 = function (t4) {
        if (!t4.ownerDocument || !t4.ownerDocument.defaultView) return null;
        try {
          return t4.ownerDocument.defaultView.frameElement;
        } catch (t5) {
          return null;
        }
      }(t3);
      return !!e2 && (e2.clientHeight < t3.scrollHeight || e2.clientWidth < t3.scrollWidth);
    }(t2);
  }
  return !1;
}
function r(t2, e2, n2, r2, i, o, l, d) {
  return o < t2 && l > e2 || o > t2 && l < e2 ? 0 : o <= t2 && d <= n2 || l >= e2 && d >= n2 ? o - t2 - r2 : l > e2 && d < n2 || o < t2 && d > n2 ? l - e2 + i : 0;
}
function index_module_default(e2, i) {
  var o = window,
    l = i.scrollMode,
    d = i.block,
    u = i.inline,
    h = i.boundary,
    a = i.skipOverflowHiddenElements,
    c = typeof h == "function" ? h : function (t2) {
      return t2 !== h;
    };
  if (!t(e2)) throw new TypeError("Invalid target");
  for (var f = document.scrollingElement || document.documentElement, s = [], p = e2; t(p) && c(p);) {
    if ((p = p.parentElement) === f) {
      s.push(p);
      break;
    }
    p != null && p === document.body && n(p) && !n(document.documentElement) || p != null && n(p, a) && s.push(p);
  }
  for (var m = o.visualViewport ? o.visualViewport.width : innerWidth, g = o.visualViewport ? o.visualViewport.height : innerHeight, w = window.scrollX || pageXOffset, v = window.scrollY || pageYOffset, W = e2.getBoundingClientRect(), b = W.height, H = W.width, y = W.top, E = W.right, M = W.bottom, V = W.left, x = d === "start" || d === "nearest" ? y : d === "end" ? M : y + b / 2, I = u === "center" ? V + H / 2 : u === "end" ? E : V, C = [], T = 0; T < s.length; T++) {
    var k = s[T],
      B = k.getBoundingClientRect(),
      D = B.height,
      O = B.width,
      R = B.top,
      X = B.right,
      Y = B.bottom,
      L = B.left;
    if (l === "if-needed" && y >= 0 && V >= 0 && M <= g && E <= m && y >= R && M <= Y && V >= L && E <= X) return C;
    var S = getComputedStyle(k),
      j = parseInt(S.borderLeftWidth, 10),
      q = parseInt(S.borderTopWidth, 10),
      z = parseInt(S.borderRightWidth, 10),
      A = parseInt(S.borderBottomWidth, 10),
      F = 0,
      G = 0,
      J = "offsetWidth" in k ? k.offsetWidth - k.clientWidth - j - z : 0,
      K = "offsetHeight" in k ? k.offsetHeight - k.clientHeight - q - A : 0;
    if (f === k) F = d === "start" ? x : d === "end" ? x - g : d === "nearest" ? r(v, v + g, g, q, A, v + x, v + x + b, b) : x - g / 2, G = u === "start" ? I : u === "center" ? I - m / 2 : u === "end" ? I - m : r(w, w + m, m, j, z, w + I, w + I + H, H), F = Math.max(0, F + v), G = Math.max(0, G + w);else {
      F = d === "start" ? x - R - q : d === "end" ? x - Y + A + K : d === "nearest" ? r(R, Y, D, q, A + K, x, x + b, b) : x - (R + D / 2) + K / 2, G = u === "start" ? I - L - j : u === "center" ? I - (L + O / 2) + J / 2 : u === "end" ? I - X + z + J : r(L, X, O, j, z + J, I, I + H, H);
      var N = k.scrollLeft,
        P = k.scrollTop;
      x += P - (F = Math.max(0, Math.min(P + F, k.scrollHeight - D + K))), I += N - (G = Math.max(0, Math.min(N + G, k.scrollWidth - O + J)));
    }
    C.push({
      el: k,
      top: F,
      left: G
    });
  }
  return C;
}
var import_tslib = __toESM(require_tslib(), 1),
  {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __metadata,
    __awaiter,
    __generator,
    __exportStar,
    __createBinding,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet
  } = import_tslib.default;
var idCounter = 0;
function cbToCb(cb) {
  return typeof cb == "function" ? cb : noop;
}
function noop() {}
function scrollIntoView(node, menuNode) {
  if (!!node) {
    var actions = index_module_default(node, {
      boundary: menuNode,
      block: "nearest",
      scrollMode: "if-needed"
    });
    actions.forEach(function (_ref) {
      var el = _ref.el,
        top = _ref.top,
        left = _ref.left;
      el.scrollTop = top, el.scrollLeft = left;
    });
  }
}
function isOrContainsNode(parent, child, environment) {
  var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
  return result;
}
function debounce(fn, time) {
  var timeoutId;
  function cancel() {
    timeoutId && clearTimeout(timeoutId);
  }
  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    cancel(), timeoutId = setTimeout(function () {
      timeoutId = null, fn.apply(void 0, args);
    }, time);
  }
  return wrapper.cancel = cancel, wrapper;
}
function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) fns[_key2] = arguments[_key2];
  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) args[_key3 - 1] = arguments[_key3];
    return fns.some(function (fn) {
      return fn && fn.apply(void 0, [event].concat(args)), event.preventDownshiftDefault || event.hasOwnProperty("nativeEvent") && event.nativeEvent.preventDownshiftDefault;
    });
  };
}
function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) refs[_key4] = arguments[_key4];
  return function (node) {
    refs.forEach(function (ref) {
      typeof ref == "function" ? ref(node) : ref && (ref.current = node);
    });
  };
}
function generateId() {
  return String(idCounter++);
}
function resetIdCounter() {
  idCounter = 0;
}
function getA11yStatusMessage$1(_ref2) {
  var isOpen = _ref2.isOpen,
    resultCount = _ref2.resultCount,
    previousResultCount = _ref2.previousResultCount;
  return isOpen ? resultCount ? resultCount !== previousResultCount ? resultCount + " result" + (resultCount === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function unwrapArray(arg, defaultValue) {
  return arg = Array.isArray(arg) ? arg[0] : arg, !arg && defaultValue ? defaultValue : arg;
}
function isDOMElement(element) {
  return typeof element.type == "string";
}
function getElementProps(element) {
  return element.props;
}
var stateKeys = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function pickState(state) {
  state === void 0 && (state = {});
  var result = {};
  return stateKeys.forEach(function (k) {
    state.hasOwnProperty(k) && (result[k] = state[k]);
  }), result;
}
function getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    return prevState[key] = isControlledProp(props, key) ? props[key] : state[key], prevState;
  }, {});
}
function isControlledProp(props, key) {
  return props[key] !== void 0;
}
function normalizeArrowKey(event) {
  var key = event.key,
    keyCode = event.keyCode;
  return keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0 ? "Arrow" + key : key;
}
function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0 && (circular = !0), itemCount === 0) return -1;
  var itemsLastIndex = itemCount - 1;
  (typeof baseIndex != "number" || baseIndex < 0 || baseIndex >= itemCount) && (baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1);
  var newIndex = baseIndex + moveAmount;
  newIndex < 0 ? newIndex = circular ? itemsLastIndex : 0 : newIndex > itemsLastIndex && (newIndex = circular ? 0 : itemsLastIndex);
  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);
  return nonDisabledNewIndex === -1 ? baseIndex >= itemCount ? -1 : baseIndex : nonDisabledNewIndex;
}
function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);
  if (!currentElementNode || !currentElementNode.hasAttribute("disabled")) return baseIndex;
  if (moveAmount > 0) {
    for (var index = baseIndex + 1; index < itemCount; index++) if (!getItemNodeFromIndex(index).hasAttribute("disabled")) return index;
  } else for (var _index = baseIndex - 1; _index >= 0; _index--) if (!getItemNodeFromIndex(_index).hasAttribute("disabled")) return _index;
  return circular ? moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, !1) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, !1) : -1;
}
function targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
  return checkActiveElement === void 0 && (checkActiveElement = !0), downshiftElements.some(function (contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target, environment) || checkActiveElement && isOrContainsNode(contextNode, environment.document.activeElement, environment));
  });
}
var cleanupStatus = debounce(function (documentProp) {
  getStatusDiv(documentProp).textContent = "";
}, 500);
function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);
  !status || (div.textContent = status, cleanupStatus(documentProp));
}
function getStatusDiv(documentProp) {
  documentProp === void 0 && (documentProp = document);
  var statusDiv = documentProp.getElementById("a11y-status-message");
  return statusDiv || (statusDiv = documentProp.createElement("div"), statusDiv.setAttribute("id", "a11y-status-message"), statusDiv.setAttribute("role", "status"), statusDiv.setAttribute("aria-live", "polite"), statusDiv.setAttribute("aria-relevant", "additions text"), Object.assign(statusDiv.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), documentProp.body.appendChild(statusDiv), statusDiv);
}
var unknown = 0,
  mouseUp = 1,
  itemMouseEnter = 2,
  keyDownArrowUp = 3,
  keyDownArrowDown = 4,
  keyDownEscape = 5,
  keyDownEnter = 6,
  keyDownHome = 7,
  keyDownEnd = 8,
  clickItem = 9,
  blurInput = 10,
  changeInput = 11,
  keyDownSpaceButton = 12,
  clickButton = 13,
  blurButton = 14,
  controlledPropUpdatedSelectedItem = 15,
  touchEnd = 16,
  stateChangeTypes$3 = Object.freeze({
    __proto__: null,
    unknown,
    mouseUp,
    itemMouseEnter,
    keyDownArrowUp,
    keyDownArrowDown,
    keyDownEscape,
    keyDownEnter,
    keyDownHome,
    keyDownEnd,
    clickItem,
    blurInput,
    changeInput,
    keyDownSpaceButton,
    clickButton,
    blurButton,
    controlledPropUpdatedSelectedItem,
    touchEnd
  }),
  _excluded$4 = ["refKey", "ref"],
  _excluded2$3 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"],
  _excluded3$2 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"],
  _excluded4$1 = ["refKey", "ref"],
  _excluded5$1 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"],
  Downshift = function () {
    var Downshift2 = function (_Component) {
      _inheritsLoose(Downshift3, _Component);
      function Downshift3(_props) {
        var _this;
        _this = _Component.call(this, _props) || this, _this.id = _this.props.id || "downshift-" + generateId(), _this.menuId = _this.props.menuId || _this.id + "-menu", _this.labelId = _this.props.labelId || _this.id + "-label", _this.inputId = _this.props.inputId || _this.id + "-input", _this.getItemId = _this.props.getItemId || function (index) {
          return _this.id + "-item-" + index;
        }, _this.input = null, _this.items = [], _this.itemCount = null, _this.previousResultCount = 0, _this.timeoutIds = [], _this.internalSetTimeout = function (fn, time) {
          var id = setTimeout(function () {
            _this.timeoutIds = _this.timeoutIds.filter(function (i) {
              return i !== id;
            }), fn();
          }, time);
          _this.timeoutIds.push(id);
        }, _this.setItemCount = function (count) {
          _this.itemCount = count;
        }, _this.unsetItemCount = function () {
          _this.itemCount = null;
        }, _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
          highlightedIndex === void 0 && (highlightedIndex = _this.props.defaultHighlightedIndex), otherStateToSet === void 0 && (otherStateToSet = {}), otherStateToSet = pickState(otherStateToSet), _this.internalSetState(_extends({
            highlightedIndex
          }, otherStateToSet));
        }, _this.clearSelection = function (cb) {
          _this.internalSetState({
            selectedItem: null,
            inputValue: "",
            highlightedIndex: _this.props.defaultHighlightedIndex,
            isOpen: _this.props.defaultIsOpen
          }, cb);
        }, _this.selectItem = function (item, otherStateToSet, cb) {
          otherStateToSet = pickState(otherStateToSet), _this.internalSetState(_extends({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            selectedItem: item,
            inputValue: _this.props.itemToString(item)
          }, otherStateToSet), cb);
        }, _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
          var item = _this.items[itemIndex];
          item != null && _this.selectItem(item, otherStateToSet, cb);
        }, _this.selectHighlightedItem = function (otherStateToSet, cb) {
          return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
        }, _this.internalSetState = function (stateToSet, cb) {
          var isItemSelected,
            onChangeArg,
            onStateChangeArg = {},
            isStateToSetFunction = typeof stateToSet == "function";
          return !isStateToSetFunction && stateToSet.hasOwnProperty("inputValue") && _this.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), stateToSet)), _this.setState(function (state) {
            state = _this.getState(state);
            var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;
            newStateToSet = _this.props.stateReducer(state, newStateToSet), isItemSelected = newStateToSet.hasOwnProperty("selectedItem");
            var nextState = {},
              nextFullState = {};
            return isItemSelected && newStateToSet.selectedItem !== state.selectedItem && (onChangeArg = newStateToSet.selectedItem), newStateToSet.type = newStateToSet.type || unknown, Object.keys(newStateToSet).forEach(function (key) {
              state[key] !== newStateToSet[key] && (onStateChangeArg[key] = newStateToSet[key]), key !== "type" && (nextFullState[key] = newStateToSet[key], isControlledProp(_this.props, key) || (nextState[key] = newStateToSet[key]));
            }), isStateToSetFunction && newStateToSet.hasOwnProperty("inputValue") && _this.props.onInputValueChange(newStateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), newStateToSet)), nextState;
          }, function () {
            cbToCb(cb)();
            var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
            hasMoreStateThanType && _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers()), isItemSelected && _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers()), onChangeArg !== void 0 && _this.props.onChange(onChangeArg, _this.getStateAndHelpers()), _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
          });
        }, _this.rootRef = function (node) {
          return _this._rootNode = node;
        }, _this.getRootProps = function (_temp, _temp2) {
          var _extends2,
            _ref = _temp === void 0 ? {} : _temp,
            _ref$refKey = _ref.refKey,
            refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey,
            ref = _ref.ref,
            rest = _objectWithoutPropertiesLoose(_ref, _excluded$4),
            _ref2 = _temp2 === void 0 ? {} : _temp2,
            _ref2$suppressRefErro = _ref2.suppressRefError,
            suppressRefError = _ref2$suppressRefErro === void 0 ? !1 : _ref2$suppressRefErro;
          _this.getRootProps.called = !0, _this.getRootProps.refKey = refKey, _this.getRootProps.suppressRefError = suppressRefError;
          var _this$getState = _this.getState(),
            isOpen = _this$getState.isOpen;
          return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = "combobox", _extends2["aria-expanded"] = isOpen, _extends2["aria-haspopup"] = "listbox", _extends2["aria-owns"] = isOpen ? _this.menuId : null, _extends2["aria-labelledby"] = _this.labelId, _extends2), rest);
        }, _this.keyDownHandlers = {
          ArrowDown: function (event) {
            var _this2 = this;
            if (event.preventDefault(), this.getState().isOpen) {
              var amount = event.shiftKey ? 5 : 1;
              this.moveHighlightedIndex(amount, {
                type: keyDownArrowDown
              });
            } else this.internalSetState({
              isOpen: !0,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this2.getItemCount();
              if (itemCount > 0) {
                var _this2$getState = _this2.getState(),
                  highlightedIndex = _this2$getState.highlightedIndex,
                  nextHighlightedIndex = getNextWrappingIndex(1, highlightedIndex, itemCount, function (index) {
                    return _this2.getItemNodeFromIndex(index);
                  });
                _this2.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          },
          ArrowUp: function (event) {
            var _this3 = this;
            if (event.preventDefault(), this.getState().isOpen) {
              var amount = event.shiftKey ? -5 : -1;
              this.moveHighlightedIndex(amount, {
                type: keyDownArrowUp
              });
            } else this.internalSetState({
              isOpen: !0,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this3.getItemCount();
              if (itemCount > 0) {
                var _this3$getState = _this3.getState(),
                  highlightedIndex = _this3$getState.highlightedIndex,
                  nextHighlightedIndex = getNextWrappingIndex(-1, highlightedIndex, itemCount, function (index) {
                    return _this3.getItemNodeFromIndex(index);
                  });
                _this3.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          },
          Enter: function (event) {
            if (event.which !== 229) {
              var _this$getState2 = this.getState(),
                isOpen = _this$getState2.isOpen,
                highlightedIndex = _this$getState2.highlightedIndex;
              if (isOpen && highlightedIndex != null) {
                event.preventDefault();
                var item = this.items[highlightedIndex],
                  itemNode = this.getItemNodeFromIndex(highlightedIndex);
                if (item == null || itemNode && itemNode.hasAttribute("disabled")) return;
                this.selectHighlightedItem({
                  type: keyDownEnter
                });
              }
            }
          },
          Escape: function (event) {
            event.preventDefault(), this.reset(_extends({
              type: keyDownEscape
            }, !this.state.isOpen && {
              selectedItem: null,
              inputValue: ""
            }));
          }
        }, _this.buttonKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
          " ": function (event) {
            event.preventDefault(), this.toggleMenu({
              type: keyDownSpaceButton
            });
          }
        }), _this.inputKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
          Home: function (event) {
            var _this4 = this,
              _this$getState3 = this.getState(),
              isOpen = _this$getState3.isOpen;
            if (!!isOpen) {
              event.preventDefault();
              var itemCount = this.getItemCount();
              if (!(itemCount <= 0 || !isOpen)) {
                var newHighlightedIndex = getNextNonDisabledIndex(1, 0, itemCount, function (index) {
                  return _this4.getItemNodeFromIndex(index);
                }, !1);
                this.setHighlightedIndex(newHighlightedIndex, {
                  type: keyDownHome
                });
              }
            }
          },
          End: function (event) {
            var _this5 = this,
              _this$getState4 = this.getState(),
              isOpen = _this$getState4.isOpen;
            if (!!isOpen) {
              event.preventDefault();
              var itemCount = this.getItemCount();
              if (!(itemCount <= 0 || !isOpen)) {
                var newHighlightedIndex = getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function (index) {
                  return _this5.getItemNodeFromIndex(index);
                }, !1);
                this.setHighlightedIndex(newHighlightedIndex, {
                  type: keyDownEnd
                });
              }
            }
          }
        }), _this.getToggleButtonProps = function (_temp3) {
          var _ref3 = _temp3 === void 0 ? {} : _temp3,
            onClick = _ref3.onClick;
          _ref3.onPress;
          var onKeyDown = _ref3.onKeyDown,
            onKeyUp = _ref3.onKeyUp,
            onBlur = _ref3.onBlur,
            rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$3),
            _this$getState5 = _this.getState(),
            isOpen = _this$getState5.isOpen,
            enabledEventHandlers = {
              onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
              onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
              onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
              onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
            },
            eventHandlers = rest.disabled ? {} : enabledEventHandlers;
          return _extends({
            type: "button",
            role: "button",
            "aria-label": isOpen ? "close menu" : "open menu",
            "aria-haspopup": !0,
            "data-toggle": !0
          }, eventHandlers, rest);
        }, _this.buttonHandleKeyUp = function (event) {
          event.preventDefault();
        }, _this.buttonHandleKeyDown = function (event) {
          var key = normalizeArrowKey(event);
          _this.buttonKeyDownHandlers[key] && _this.buttonKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }, _this.buttonHandleClick = function (event) {
          event.preventDefault(), _this.props.environment.document.activeElement === _this.props.environment.document.body && event.target.focus(), _this.internalSetTimeout(function () {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }, _this.buttonHandleBlur = function (event) {
          var blurTarget = event.target;
          _this.internalSetTimeout(function () {
            !_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget && _this.reset({
              type: blurButton
            });
          });
        }, _this.getLabelProps = function (props) {
          return _extends({
            htmlFor: _this.inputId,
            id: _this.labelId
          }, props);
        }, _this.getInputProps = function (_temp4) {
          var _ref4 = _temp4 === void 0 ? {} : _temp4,
            onKeyDown = _ref4.onKeyDown,
            onBlur = _ref4.onBlur,
            onChange = _ref4.onChange,
            onInput = _ref4.onInput;
          _ref4.onChangeText;
          var rest = _objectWithoutPropertiesLoose(_ref4, _excluded3$2),
            onChangeKey,
            eventHandlers = {};
          onChangeKey = "onChange";
          var _this$getState6 = _this.getState(),
            inputValue = _this$getState6.inputValue,
            isOpen = _this$getState6.isOpen,
            highlightedIndex = _this$getState6.highlightedIndex;
          if (!rest.disabled) {
            var _eventHandlers;
            eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
          }
          return _extends({
            "aria-autocomplete": "list",
            "aria-activedescendant": isOpen && typeof highlightedIndex == "number" && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
            "aria-controls": isOpen ? _this.menuId : null,
            "aria-labelledby": _this.labelId,
            autoComplete: "off",
            value: inputValue,
            id: _this.inputId
          }, eventHandlers, rest);
        }, _this.inputHandleKeyDown = function (event) {
          var key = normalizeArrowKey(event);
          key && _this.inputKeyDownHandlers[key] && _this.inputKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }, _this.inputHandleChange = function (event) {
          _this.internalSetState({
            type: changeInput,
            isOpen: !0,
            inputValue: event.target.value,
            highlightedIndex: _this.props.defaultHighlightedIndex
          });
        }, _this.inputHandleBlur = function () {
          _this.internalSetTimeout(function () {
            var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);
            !_this.isMouseDown && !downshiftButtonIsActive && _this.reset({
              type: blurInput
            });
          });
        }, _this.menuRef = function (node) {
          _this._menuNode = node;
        }, _this.getMenuProps = function (_temp5, _temp6) {
          var _extends3,
            _ref5 = _temp5 === void 0 ? {} : _temp5,
            _ref5$refKey = _ref5.refKey,
            refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey,
            ref = _ref5.ref,
            props = _objectWithoutPropertiesLoose(_ref5, _excluded4$1),
            _ref6 = _temp6 === void 0 ? {} : _temp6,
            _ref6$suppressRefErro = _ref6.suppressRefError,
            suppressRefError = _ref6$suppressRefErro === void 0 ? !1 : _ref6$suppressRefErro;
          return _this.getMenuProps.called = !0, _this.getMenuProps.refKey = refKey, _this.getMenuProps.suppressRefError = suppressRefError, _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = "listbox", _extends3["aria-labelledby"] = props && props["aria-label"] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
        }, _this.getItemProps = function (_temp7) {
          var _enabledEventHandlers,
            _ref7 = _temp7 === void 0 ? {} : _temp7,
            onMouseMove = _ref7.onMouseMove,
            onMouseDown = _ref7.onMouseDown,
            onClick = _ref7.onClick;
          _ref7.onPress;
          var index = _ref7.index,
            _ref7$item = _ref7.item,
            item = _ref7$item === void 0 ? void 0 : _ref7$item,
            rest = _objectWithoutPropertiesLoose(_ref7, _excluded5$1);
          index === void 0 ? (_this.items.push(item), index = _this.items.indexOf(item)) : _this.items[index] = item;
          var onSelectKey = "onClick",
            customClickHandler = onClick,
            enabledEventHandlers = (_enabledEventHandlers = {
              onMouseMove: callAllEventHandlers(onMouseMove, function () {
                index !== _this.getState().highlightedIndex && (_this.setHighlightedIndex(index, {
                  type: itemMouseEnter
                }), _this.avoidScrolling = !0, _this.internalSetTimeout(function () {
                  return _this.avoidScrolling = !1;
                }, 250));
              }),
              onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
                event.preventDefault();
              })
            }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
              _this.selectItemAtIndex(index, {
                type: clickItem
              });
            }), _enabledEventHandlers),
            eventHandlers = rest.disabled ? {
              onMouseDown: enabledEventHandlers.onMouseDown
            } : enabledEventHandlers;
          return _extends({
            id: _this.getItemId(index),
            role: "option",
            "aria-selected": _this.getState().highlightedIndex === index
          }, eventHandlers, rest);
        }, _this.clearItems = function () {
          _this.items = [];
        }, _this.reset = function (otherStateToSet, cb) {
          otherStateToSet === void 0 && (otherStateToSet = {}), otherStateToSet = pickState(otherStateToSet), _this.internalSetState(function (_ref8) {
            var selectedItem = _ref8.selectedItem;
            return _extends({
              isOpen: _this.props.defaultIsOpen,
              highlightedIndex: _this.props.defaultHighlightedIndex,
              inputValue: _this.props.itemToString(selectedItem)
            }, otherStateToSet);
          }, cb);
        }, _this.toggleMenu = function (otherStateToSet, cb) {
          otherStateToSet === void 0 && (otherStateToSet = {}), otherStateToSet = pickState(otherStateToSet), _this.internalSetState(function (_ref9) {
            var isOpen = _ref9.isOpen;
            return _extends({
              isOpen: !isOpen
            }, isOpen && {
              highlightedIndex: _this.props.defaultHighlightedIndex
            }, otherStateToSet);
          }, function () {
            var _this$getState7 = _this.getState(),
              isOpen = _this$getState7.isOpen,
              highlightedIndex = _this$getState7.highlightedIndex;
            isOpen && _this.getItemCount() > 0 && typeof highlightedIndex == "number" && _this.setHighlightedIndex(highlightedIndex, otherStateToSet), cbToCb(cb)();
          });
        }, _this.openMenu = function (cb) {
          _this.internalSetState({
            isOpen: !0
          }, cb);
        }, _this.closeMenu = function (cb) {
          _this.internalSetState({
            isOpen: !1
          }, cb);
        }, _this.updateStatus = debounce(function () {
          var state = _this.getState(),
            item = _this.items[state.highlightedIndex],
            resultCount = _this.getItemCount(),
            status = _this.props.getA11yStatusMessage(_extends({
              itemToString: _this.props.itemToString,
              previousResultCount: _this.previousResultCount,
              resultCount,
              highlightedItem: item
            }, state));
          _this.previousResultCount = resultCount, setStatus(status, _this.props.environment.document);
        }, 200);
        var _this$props = _this.props,
          defaultHighlightedIndex = _this$props.defaultHighlightedIndex,
          _this$props$initialHi = _this$props.initialHighlightedIndex,
          _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi,
          defaultIsOpen = _this$props.defaultIsOpen,
          _this$props$initialIs = _this$props.initialIsOpen,
          _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs,
          _this$props$initialIn = _this$props.initialInputValue,
          _inputValue = _this$props$initialIn === void 0 ? "" : _this$props$initialIn,
          _this$props$initialSe = _this$props.initialSelectedItem,
          _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe,
          _state = _this.getState({
            highlightedIndex: _highlightedIndex,
            isOpen: _isOpen,
            inputValue: _inputValue,
            selectedItem: _selectedItem
          });
        return _state.selectedItem != null && _this.props.initialInputValue === void 0 && (_state.inputValue = _this.props.itemToString(_state.selectedItem)), _this.state = _state, _this;
      }
      var _proto = Downshift3.prototype;
      return _proto.internalClearTimeouts = function () {
        this.timeoutIds.forEach(function (id) {
          clearTimeout(id);
        }), this.timeoutIds = [];
      }, _proto.getState = function (stateToMerge) {
        return stateToMerge === void 0 && (stateToMerge = this.state), getState(stateToMerge, this.props);
      }, _proto.getItemCount = function () {
        var itemCount = this.items.length;
        return this.itemCount != null ? itemCount = this.itemCount : this.props.itemCount !== void 0 && (itemCount = this.props.itemCount), itemCount;
      }, _proto.getItemNodeFromIndex = function (index) {
        return this.props.environment.document.getElementById(this.getItemId(index));
      }, _proto.scrollHighlightedItemIntoView = function () {
        {
          var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
          this.props.scrollIntoView(node, this._menuNode);
        }
      }, _proto.moveHighlightedIndex = function (amount, otherStateToSet) {
        var _this6 = this,
          itemCount = this.getItemCount(),
          _this$getState8 = this.getState(),
          highlightedIndex = _this$getState8.highlightedIndex;
        if (itemCount > 0) {
          var nextHighlightedIndex = getNextWrappingIndex(amount, highlightedIndex, itemCount, function (index) {
            return _this6.getItemNodeFromIndex(index);
          });
          this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
        }
      }, _proto.getStateAndHelpers = function () {
        var _this$getState9 = this.getState(),
          highlightedIndex = _this$getState9.highlightedIndex,
          inputValue = _this$getState9.inputValue,
          selectedItem = _this$getState9.selectedItem,
          isOpen = _this$getState9.isOpen,
          itemToString2 = this.props.itemToString,
          id = this.id,
          getRootProps = this.getRootProps,
          getToggleButtonProps = this.getToggleButtonProps,
          getLabelProps = this.getLabelProps,
          getMenuProps = this.getMenuProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount,
          setState = this.internalSetState;
        return {
          getRootProps,
          getToggleButtonProps,
          getLabelProps,
          getMenuProps,
          getInputProps,
          getItemProps,
          reset,
          openMenu,
          closeMenu,
          toggleMenu,
          selectItem,
          selectItemAtIndex,
          selectHighlightedItem,
          setHighlightedIndex,
          clearSelection,
          clearItems,
          setItemCount,
          unsetItemCount,
          setState,
          itemToString: itemToString2,
          id,
          highlightedIndex,
          inputValue,
          isOpen,
          selectedItem
        };
      }, _proto.componentDidMount = function () {
        var _this7 = this;
        {
          var onMouseDown = function () {
              _this7.isMouseDown = !0;
            },
            onMouseUp = function (event) {
              _this7.isMouseDown = !1;
              var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment);
              !contextWithinDownshift && _this7.getState().isOpen && _this7.reset({
                type: mouseUp
              }, function () {
                return _this7.props.onOuterClick(_this7.getStateAndHelpers());
              });
            },
            onTouchStart = function () {
              _this7.isTouchMove = !1;
            },
            onTouchMove = function () {
              _this7.isTouchMove = !0;
            },
            onTouchEnd = function (event) {
              var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment, !1);
              !_this7.isTouchMove && !contextWithinDownshift && _this7.getState().isOpen && _this7.reset({
                type: touchEnd
              }, function () {
                return _this7.props.onOuterClick(_this7.getStateAndHelpers());
              });
            },
            environment = this.props.environment;
          environment.addEventListener("mousedown", onMouseDown), environment.addEventListener("mouseup", onMouseUp), environment.addEventListener("touchstart", onTouchStart), environment.addEventListener("touchmove", onTouchMove), environment.addEventListener("touchend", onTouchEnd), this.cleanup = function () {
            _this7.internalClearTimeouts(), _this7.updateStatus.cancel(), environment.removeEventListener("mousedown", onMouseDown), environment.removeEventListener("mouseup", onMouseUp), environment.removeEventListener("touchstart", onTouchStart), environment.removeEventListener("touchmove", onTouchMove), environment.removeEventListener("touchend", onTouchEnd);
          };
        }
      }, _proto.shouldScroll = function (prevState, prevProps) {
        var _ref10 = this.props.highlightedIndex === void 0 ? this.getState() : this.props,
          currentHighlightedIndex = _ref10.highlightedIndex,
          _ref11 = prevProps.highlightedIndex === void 0 ? prevState : prevProps,
          prevHighlightedIndex = _ref11.highlightedIndex,
          scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen,
          scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
        return scrollWhenOpen || scrollWhenNavigating;
      }, _proto.componentDidUpdate = function (prevProps, prevState) {
        isControlledProp(this.props, "selectedItem") && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem) && this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        }), !this.avoidScrolling && this.shouldScroll(prevState, prevProps) && this.scrollHighlightedItemIntoView(), this.updateStatus();
      }, _proto.componentWillUnmount = function () {
        this.cleanup();
      }, _proto.render = function () {
        var children = unwrapArray(this.props.children, noop);
        this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
        var element = unwrapArray(children(this.getStateAndHelpers()));
        if (!element) return null;
        if (this.getRootProps.called || this.props.suppressRefError) return element;
        if (isDOMElement(element)) return cloneElement(element, this.getRootProps(getElementProps(element)));
      }, Downshift3;
    }(Component);
    return Downshift2.defaultProps = {
      defaultHighlightedIndex: null,
      defaultIsOpen: !1,
      getA11yStatusMessage: getA11yStatusMessage$1,
      itemToString: function (i) {
        return i == null ? "" : String(i);
      },
      onStateChange: noop,
      onInputValueChange: noop,
      onUserAction: noop,
      onChange: noop,
      onSelect: noop,
      onOuterClick: noop,
      selectedItemChanged: function (prevItem, item) {
        return prevItem !== item;
      },
      environment: typeof window > "u" ? {} : window,
      stateReducer: function (state, stateToSet) {
        return stateToSet;
      },
      suppressRefError: !1,
      scrollIntoView
    }, Downshift2.stateChangeTypes = stateChangeTypes$3, Downshift2;
  }(),
  Downshift$1 = Downshift;
var _excluded$3 = ["isInitialMount", "highlightedIndex", "items", "environment"],
  dropdownDefaultStateValues = {
    highlightedIndex: -1,
    isOpen: !1,
    selectedItem: null,
    inputValue: ""
  };
function callOnChangeProps(action, state, newState) {
  var props = action.props,
    type = action.type,
    changes = {};
  Object.keys(state).forEach(function (key) {
    invokeOnChangeHandler(key, action, state, newState), newState[key] !== state[key] && (changes[key] = newState[key]);
  }), props.onStateChange && Object.keys(changes).length && props.onStateChange(_extends({
    type
  }, changes));
}
function invokeOnChangeHandler(key, action, state, newState) {
  var props = action.props,
    type = action.type,
    handler = "on" + capitalizeString(key) + "Change";
  props[handler] && newState[key] !== void 0 && newState[key] !== state[key] && props[handler](_extends({
    type
  }, newState));
}
function stateReducer(s, a) {
  return a.changes;
}
function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem,
    itemToStringLocal = selectionParameters.itemToString;
  return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : "";
}
var updateA11yStatus = debounce(function (getA11yMessage, document2) {
    setStatus(getA11yMessage(), document2);
  }, 200),
  useIsomorphicLayoutEffect = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? useLayoutEffect : useEffect;
function useElementIds(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "downshift-" + generateId() : _ref$id,
    labelId = _ref.labelId,
    menuId = _ref.menuId,
    getItemId = _ref.getItemId,
    toggleButtonId = _ref.toggleButtonId,
    inputId = _ref.inputId,
    elementIdsRef = useRef({
      labelId: labelId || id + "-label",
      menuId: menuId || id + "-menu",
      getItemId: getItemId || function (index) {
        return id + "-item-" + index;
      },
      toggleButtonId: toggleButtonId || id + "-toggle-button",
      inputId: inputId || id + "-input"
    });
  return elementIdsRef.current;
}
function getItemIndex(index, item, items) {
  return index !== void 0 ? index : items.length === 0 ? -1 : items.indexOf(item);
}
function itemToString(item) {
  return item ? String(item) : "";
}
function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}
function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}
function useLatestRef(val) {
  var ref = useRef(val);
  return ref.current = val, ref;
}
function useEnhancedReducer(reducer, initialState, props) {
  var prevStateRef = useRef(),
    actionRef = useRef(),
    enhancedReducer = useCallback(function (state2, action2) {
      actionRef.current = action2, state2 = getState(state2, action2.props);
      var changes = reducer(state2, action2),
        newState = action2.props.stateReducer(state2, _extends({}, action2, {
          changes
        }));
      return newState;
    }, [reducer]),
    _useReducer = useReducer(enhancedReducer, initialState),
    state = _useReducer[0],
    dispatch = _useReducer[1],
    propsRef = useLatestRef(props),
    dispatchWithProps = useCallback(function (action2) {
      return dispatch(_extends({
        props: propsRef.current
      }, action2));
    }, [propsRef]),
    action = actionRef.current;
  return useEffect(function () {
    action && prevStateRef.current && prevStateRef.current !== state && callOnChangeProps(action, getState(prevStateRef.current, action.props), state), prevStateRef.current = state;
  }, [state, props, action]), [state, dispatchWithProps];
}
function useControlledReducer$1(reducer, initialState, props) {
  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
    state = _useEnhancedReducer[0],
    dispatch = _useEnhancedReducer[1];
  return [getState(state, props), dispatch];
}
var defaultProps$3 = {
  itemToString,
  stateReducer,
  getA11ySelectionMessage,
  scrollIntoView,
  circularNavigation: !1,
  environment: typeof window > "u" ? {} : window
};
function getDefaultValue$1(props, propKey, defaultStateValues2) {
  defaultStateValues2 === void 0 && (defaultStateValues2 = dropdownDefaultStateValues);
  var defaultPropKey = "default" + capitalizeString(propKey);
  return defaultPropKey in props ? props[defaultPropKey] : defaultStateValues2[propKey];
}
function getInitialValue$1(props, propKey, defaultStateValues2) {
  if (defaultStateValues2 === void 0 && (defaultStateValues2 = dropdownDefaultStateValues), propKey in props) return props[propKey];
  var initialPropKey = "initial" + capitalizeString(propKey);
  return initialPropKey in props ? props[initialPropKey] : getDefaultValue$1(props, propKey, defaultStateValues2);
}
function getInitialState$2(props) {
  var selectedItem = getInitialValue$1(props, "selectedItem"),
    isOpen = getInitialValue$1(props, "isOpen"),
    highlightedIndex = getInitialValue$1(props, "highlightedIndex"),
    inputValue = getInitialValue$1(props, "inputValue");
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen,
    selectedItem,
    inputValue
  };
}
function getHighlightedIndexOnOpen(props, state, offset, getItemNodeFromIndex) {
  var items = props.items,
    initialHighlightedIndex = props.initialHighlightedIndex,
    defaultHighlightedIndex = props.defaultHighlightedIndex,
    selectedItem = state.selectedItem,
    highlightedIndex = state.highlightedIndex;
  return items.length === 0 ? -1 : initialHighlightedIndex !== void 0 && highlightedIndex === initialHighlightedIndex ? initialHighlightedIndex : defaultHighlightedIndex !== void 0 ? defaultHighlightedIndex : selectedItem ? offset === 0 ? items.indexOf(selectedItem) : getNextWrappingIndex(offset, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, !1) : offset === 0 ? -1 : offset < 0 ? items.length - 1 : 0;
}
function useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
  var mouseAndTouchTrackersRef = useRef({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return useEffect(function () {
    var onMouseDown = function () {
        mouseAndTouchTrackersRef.current.isMouseDown = !0;
      },
      onMouseUp = function (event) {
        mouseAndTouchTrackersRef.current.isMouseDown = !1, isOpen && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
          return ref.current;
        }), environment) && handleBlur();
      },
      onTouchStart = function () {
        mouseAndTouchTrackersRef.current.isTouchMove = !1;
      },
      onTouchMove = function () {
        mouseAndTouchTrackersRef.current.isTouchMove = !0;
      },
      onTouchEnd = function (event) {
        isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
          return ref.current;
        }), environment, !1) && handleBlur();
      };
    return environment.addEventListener("mousedown", onMouseDown), environment.addEventListener("mouseup", onMouseUp), environment.addEventListener("touchstart", onTouchStart), environment.addEventListener("touchmove", onTouchMove), environment.addEventListener("touchend", onTouchEnd), function () {
      environment.removeEventListener("mousedown", onMouseDown), environment.removeEventListener("mouseup", onMouseUp), environment.removeEventListener("touchstart", onTouchStart), environment.removeEventListener("touchmove", onTouchMove), environment.removeEventListener("touchend", onTouchEnd);
    };
  }, [isOpen, environment]), mouseAndTouchTrackersRef;
}
var useGetterPropsCalledChecker = function () {
  return noop;
};
function useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
  var isInitialMount = _ref2.isInitialMount,
    highlightedIndex = _ref2.highlightedIndex,
    items = _ref2.items,
    environment = _ref2.environment,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$3);
  useEffect(function () {
    isInitialMount || updateA11yStatus(function () {
      return getA11yMessage(_extends({
        highlightedIndex,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length
      }, rest));
    }, environment.document);
  }, dependencyArray);
}
function useScrollIntoView(_ref3) {
  var highlightedIndex = _ref3.highlightedIndex,
    isOpen = _ref3.isOpen,
    itemRefs = _ref3.itemRefs,
    getItemNodeFromIndex = _ref3.getItemNodeFromIndex,
    menuElement = _ref3.menuElement,
    scrollIntoViewProp = _ref3.scrollIntoView,
    shouldScrollRef = useRef(!0);
  return useIsomorphicLayoutEffect(function () {
    highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length || (shouldScrollRef.current === !1 ? shouldScrollRef.current = !0 : scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement));
  }, [highlightedIndex]), shouldScrollRef;
}
var useControlPropsValidator = noop;
function downshiftCommonReducer(state, action, stateChangeTypes2) {
  var type = action.type,
    props = action.props,
    changes;
  switch (type) {
    case stateChangeTypes2.ItemMouseMove:
      changes = {
        highlightedIndex: action.index
      };
      break;
    case stateChangeTypes2.MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;
    case stateChangeTypes2.ToggleButtonClick:
    case stateChangeTypes2.FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes2.FunctionOpenMenu:
      changes = {
        isOpen: !0,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes2.FunctionCloseMenu:
      changes = {
        isOpen: !1
      };
      break;
    case stateChangeTypes2.FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;
    case stateChangeTypes2.FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;
    case stateChangeTypes2.FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex"),
        isOpen: getDefaultValue$1(props, "isOpen"),
        selectedItem: getDefaultValue$1(props, "selectedItem"),
        inputValue: getDefaultValue$1(props, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return _extends({}, state, changes);
}
function getItemIndexByCharacterKey(_a) {
  for (var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString2 = _a.itemToString, getItemNodeFromIndex = _a.getItemNodeFromIndex, lowerCasedKeysSoFar = keysSoFar.toLowerCase(), index = 0; index < items.length; index++) {
    var offsetIndex = (index + highlightedIndex + 1) % items.length,
      item = items[offsetIndex];
    if (item !== void 0 && itemToString2(item).toLowerCase().startsWith(lowerCasedKeysSoFar)) {
      var element = getItemNodeFromIndex(offsetIndex);
      if (!(element != null && element.hasAttribute("disabled"))) return offsetIndex;
    }
  }
  return highlightedIndex;
}
var propTypes$2 = {
  items: import_prop_types.default.array.isRequired,
  itemToString: import_prop_types.default.func,
  getA11yStatusMessage: import_prop_types.default.func,
  getA11ySelectionMessage: import_prop_types.default.func,
  circularNavigation: import_prop_types.default.bool,
  highlightedIndex: import_prop_types.default.number,
  defaultHighlightedIndex: import_prop_types.default.number,
  initialHighlightedIndex: import_prop_types.default.number,
  isOpen: import_prop_types.default.bool,
  defaultIsOpen: import_prop_types.default.bool,
  initialIsOpen: import_prop_types.default.bool,
  selectedItem: import_prop_types.default.any,
  initialSelectedItem: import_prop_types.default.any,
  defaultSelectedItem: import_prop_types.default.any,
  id: import_prop_types.default.string,
  labelId: import_prop_types.default.string,
  menuId: import_prop_types.default.string,
  getItemId: import_prop_types.default.func,
  toggleButtonId: import_prop_types.default.string,
  stateReducer: import_prop_types.default.func,
  onSelectedItemChange: import_prop_types.default.func,
  onHighlightedIndexChange: import_prop_types.default.func,
  onStateChange: import_prop_types.default.func,
  onIsOpenChange: import_prop_types.default.func,
  environment: import_prop_types.default.shape({
    addEventListener: import_prop_types.default.func,
    removeEventListener: import_prop_types.default.func,
    document: import_prop_types.default.shape({
      getElementById: import_prop_types.default.func,
      activeElement: import_prop_types.default.any,
      body: import_prop_types.default.any
    })
  })
};
function getA11yStatusMessage(_a) {
  var isOpen = _a.isOpen,
    resultCount = _a.resultCount,
    previousResultCount = _a.previousResultCount;
  return isOpen ? resultCount ? resultCount !== previousResultCount ? resultCount + " result" + (resultCount === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select." : "" : "No results are available." : "";
}
var defaultProps$2 = __assign(__assign({}, defaultProps$3), {
    getA11yStatusMessage
  }),
  validatePropTypes$2 = noop,
  MenuKeyDownArrowDown = 0,
  MenuKeyDownArrowUp = 1,
  MenuKeyDownEscape = 2,
  MenuKeyDownHome = 3,
  MenuKeyDownEnd = 4,
  MenuKeyDownEnter = 5,
  MenuKeyDownSpaceButton = 6,
  MenuKeyDownCharacter = 7,
  MenuBlur = 8,
  MenuMouseLeave$1 = 9,
  ItemMouseMove$1 = 10,
  ItemClick$1 = 11,
  ToggleButtonClick$1 = 12,
  ToggleButtonKeyDownArrowDown = 13,
  ToggleButtonKeyDownArrowUp = 14,
  ToggleButtonKeyDownCharacter = 15,
  FunctionToggleMenu$1 = 16,
  FunctionOpenMenu$1 = 17,
  FunctionCloseMenu$1 = 18,
  FunctionSetHighlightedIndex$1 = 19,
  FunctionSelectItem$1 = 20,
  FunctionSetInputValue$1 = 21,
  FunctionReset$2 = 22,
  stateChangeTypes$2 = Object.freeze({
    __proto__: null,
    MenuKeyDownArrowDown,
    MenuKeyDownArrowUp,
    MenuKeyDownEscape,
    MenuKeyDownHome,
    MenuKeyDownEnd,
    MenuKeyDownEnter,
    MenuKeyDownSpaceButton,
    MenuKeyDownCharacter,
    MenuBlur,
    MenuMouseLeave: MenuMouseLeave$1,
    ItemMouseMove: ItemMouseMove$1,
    ItemClick: ItemClick$1,
    ToggleButtonClick: ToggleButtonClick$1,
    ToggleButtonKeyDownArrowDown,
    ToggleButtonKeyDownArrowUp,
    ToggleButtonKeyDownCharacter,
    FunctionToggleMenu: FunctionToggleMenu$1,
    FunctionOpenMenu: FunctionOpenMenu$1,
    FunctionCloseMenu: FunctionCloseMenu$1,
    FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
    FunctionSelectItem: FunctionSelectItem$1,
    FunctionSetInputValue: FunctionSetInputValue$1,
    FunctionReset: FunctionReset$2
  });
function downshiftSelectReducer(state, action) {
  var type = action.type,
    props = action.props,
    shiftKey = action.shiftKey,
    changes;
  switch (type) {
    case ItemClick$1:
      changes = {
        isOpen: getDefaultValue$1(props, "isOpen"),
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex"),
        selectedItem: props.items[action.index]
      };
      break;
    case ToggleButtonKeyDownCharacter:
      {
        var lowercasedKey = action.key,
          inputValue = "" + state.inputValue + lowercasedKey,
          itemIndex = getItemIndexByCharacterKey({
            keysSoFar: inputValue,
            highlightedIndex: state.selectedItem ? props.items.indexOf(state.selectedItem) : -1,
            items: props.items,
            itemToString: props.itemToString,
            getItemNodeFromIndex: action.getItemNodeFromIndex
          });
        changes = _extends({
          inputValue
        }, itemIndex >= 0 && {
          selectedItem: props.items[itemIndex]
        });
      }
      break;
    case ToggleButtonKeyDownArrowDown:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
        isOpen: !0
      };
      break;
    case ToggleButtonKeyDownArrowUp:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
        isOpen: !0
      };
      break;
    case MenuKeyDownEnter:
    case MenuKeyDownSpaceButton:
      changes = _extends({
        isOpen: getDefaultValue$1(props, "isOpen"),
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex")
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;
    case MenuKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, !1)
      };
      break;
    case MenuKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, !1)
      };
      break;
    case MenuKeyDownEscape:
      changes = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case MenuBlur:
      changes = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case MenuKeyDownCharacter:
      {
        var _lowercasedKey = action.key,
          _inputValue = "" + state.inputValue + _lowercasedKey,
          highlightedIndex = getItemIndexByCharacterKey({
            keysSoFar: _inputValue,
            highlightedIndex: state.highlightedIndex,
            items: props.items,
            itemToString: props.itemToString,
            getItemNodeFromIndex: action.getItemNodeFromIndex
          });
        changes = _extends({
          inputValue: _inputValue
        }, highlightedIndex >= 0 && {
          highlightedIndex
        });
      }
      break;
    case MenuKeyDownArrowDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;
    case MenuKeyDownArrowUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;
    case FunctionSelectItem$1:
      changes = {
        selectedItem: action.selectedItem
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$2);
  }
  return _extends({}, state, changes);
}
var _excluded$2 = ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"],
  _excluded2$2 = ["onClick", "onKeyDown", "refKey", "ref"],
  _excluded3$1 = ["item", "index", "onMouseMove", "onClick", "refKey", "ref"];
useSelect.stateChangeTypes = stateChangeTypes$2;
function useSelect(userProps) {
  userProps === void 0 && (userProps = {}), validatePropTypes$2(userProps, useSelect);
  var props = _extends({}, defaultProps$2, userProps),
    items = props.items,
    scrollIntoView2 = props.scrollIntoView,
    environment = props.environment,
    initialIsOpen = props.initialIsOpen,
    defaultIsOpen = props.defaultIsOpen,
    itemToString2 = props.itemToString,
    getA11ySelectionMessage2 = props.getA11ySelectionMessage,
    getA11yStatusMessage2 = props.getA11yStatusMessage,
    initialState = getInitialState$2(props),
    _useControlledReducer = useControlledReducer$1(downshiftSelectReducer, initialState, props),
    state = _useControlledReducer[0],
    dispatch = _useControlledReducer[1],
    isOpen = state.isOpen,
    highlightedIndex = state.highlightedIndex,
    selectedItem = state.selectedItem,
    inputValue = state.inputValue,
    toggleButtonRef = useRef(null),
    menuRef = useRef(null),
    itemRefs = useRef({}),
    shouldBlurRef = useRef(!0),
    clearTimeoutRef = useRef(null),
    elementIds = useElementIds(props),
    previousResultCountRef = useRef(),
    isInitialMountRef = useRef(!0),
    latest = useLatestRef({
      state,
      props
    }),
    getItemNodeFromIndex = useCallback(function (index) {
      return itemRefs.current[elementIds.getItemId(index)];
    }, [elementIds]);
  useA11yMessageSetter(getA11yStatusMessage2, [isOpen, highlightedIndex, inputValue, items], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state)), useA11yMessageSetter(getA11ySelectionMessage2, [selectedItem], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex,
    isOpen,
    itemRefs,
    scrollIntoView: scrollIntoView2,
    getItemNodeFromIndex
  });
  useEffect(function () {
    return clearTimeoutRef.current = debounce(function (outerDispatch) {
      outerDispatch({
        type: FunctionSetInputValue$1,
        inputValue: ""
      });
    }, 500), function () {
      clearTimeoutRef.current.cancel();
    };
  }, []), useEffect(function () {
    !inputValue || clearTimeoutRef.current(dispatch);
  }, [dispatch, inputValue]), useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props,
    state
  }), useEffect(function () {
    if (isInitialMountRef.current) {
      (initialIsOpen || defaultIsOpen || isOpen) && menuRef.current && menuRef.current.focus();
      return;
    }
    if (isOpen) {
      menuRef.current && menuRef.current.focus();
      return;
    }
    environment.document.activeElement === menuRef.current && toggleButtonRef.current && (shouldBlurRef.current = !1, toggleButtonRef.current.focus());
  }, [isOpen]), useEffect(function () {
    isInitialMountRef.current || (previousResultCountRef.current = items.length);
  });
  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [menuRef, toggleButtonRef], environment, function () {
      dispatch({
        type: MenuBlur
      });
    }),
    setGetterPropCallInfo = useGetterPropsCalledChecker("getMenuProps", "getToggleButtonProps");
  useEffect(function () {
    isInitialMountRef.current = !1;
  }, []), useEffect(function () {
    isOpen || (itemRefs.current = {});
  }, [isOpen]);
  var toggleButtonKeyDownHandlers = useMemo(function () {
      return {
        ArrowDown: function (event) {
          event.preventDefault(), dispatch({
            type: ToggleButtonKeyDownArrowDown,
            getItemNodeFromIndex,
            shiftKey: event.shiftKey
          });
        },
        ArrowUp: function (event) {
          event.preventDefault(), dispatch({
            type: ToggleButtonKeyDownArrowUp,
            getItemNodeFromIndex,
            shiftKey: event.shiftKey
          });
        }
      };
    }, [dispatch, getItemNodeFromIndex]),
    menuKeyDownHandlers = useMemo(function () {
      return {
        ArrowDown: function (event) {
          event.preventDefault(), dispatch({
            type: MenuKeyDownArrowDown,
            getItemNodeFromIndex,
            shiftKey: event.shiftKey
          });
        },
        ArrowUp: function (event) {
          event.preventDefault(), dispatch({
            type: MenuKeyDownArrowUp,
            getItemNodeFromIndex,
            shiftKey: event.shiftKey
          });
        },
        Home: function (event) {
          event.preventDefault(), dispatch({
            type: MenuKeyDownHome,
            getItemNodeFromIndex
          });
        },
        End: function (event) {
          event.preventDefault(), dispatch({
            type: MenuKeyDownEnd,
            getItemNodeFromIndex
          });
        },
        Escape: function () {
          dispatch({
            type: MenuKeyDownEscape
          });
        },
        Enter: function (event) {
          event.preventDefault(), dispatch({
            type: MenuKeyDownEnter
          });
        },
        " ": function (event) {
          event.preventDefault(), dispatch({
            type: MenuKeyDownSpaceButton
          });
        }
      };
    }, [dispatch, getItemNodeFromIndex]),
    toggleMenu = useCallback(function () {
      dispatch({
        type: FunctionToggleMenu$1
      });
    }, [dispatch]),
    closeMenu = useCallback(function () {
      dispatch({
        type: FunctionCloseMenu$1
      });
    }, [dispatch]),
    openMenu = useCallback(function () {
      dispatch({
        type: FunctionOpenMenu$1
      });
    }, [dispatch]),
    setHighlightedIndex = useCallback(function (newHighlightedIndex) {
      dispatch({
        type: FunctionSetHighlightedIndex$1,
        highlightedIndex: newHighlightedIndex
      });
    }, [dispatch]),
    selectItem = useCallback(function (newSelectedItem) {
      dispatch({
        type: FunctionSelectItem$1,
        selectedItem: newSelectedItem
      });
    }, [dispatch]),
    reset = useCallback(function () {
      dispatch({
        type: FunctionReset$2
      });
    }, [dispatch]),
    setInputValue = useCallback(function (newInputValue) {
      dispatch({
        type: FunctionSetInputValue$1,
        inputValue: newInputValue
      });
    }, [dispatch]),
    getLabelProps = useCallback(function (labelProps) {
      return _extends({
        id: elementIds.labelId,
        htmlFor: elementIds.toggleButtonId
      }, labelProps);
    }, [elementIds]),
    getMenuProps = useCallback(function (_temp, _temp2) {
      var _extends2,
        _ref = _temp === void 0 ? {} : _temp,
        onMouseLeave = _ref.onMouseLeave,
        _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey,
        onKeyDown = _ref.onKeyDown,
        onBlur = _ref.onBlur,
        ref = _ref.ref,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded$2),
        _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$suppressRefErro = _ref2.suppressRefError,
        suppressRefError = _ref2$suppressRefErro === void 0 ? !1 : _ref2$suppressRefErro,
        latestState = latest.current.state,
        menuHandleKeyDown = function (event) {
          var key = normalizeArrowKey(event);
          key && menuKeyDownHandlers[key] ? menuKeyDownHandlers[key](event) : isAcceptedCharacterKey(key) && dispatch({
            type: MenuKeyDownCharacter,
            key,
            getItemNodeFromIndex
          });
        },
        menuHandleBlur = function () {
          if (shouldBlurRef.current === !1) {
            shouldBlurRef.current = !0;
            return;
          }
          var shouldBlur = !mouseAndTouchTrackersRef.current.isMouseDown;
          shouldBlur && dispatch({
            type: MenuBlur
          });
        },
        menuHandleMouseLeave = function () {
          dispatch({
            type: MenuMouseLeave$1
          });
        };
      return setGetterPropCallInfo("getMenuProps", suppressRefError, refKey, menuRef), _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
        menuRef.current = menuNode;
      }), _extends2.id = elementIds.menuId, _extends2.role = "listbox", _extends2["aria-labelledby"] = elementIds.labelId, _extends2.tabIndex = -1, _extends2), latestState.isOpen && latestState.highlightedIndex > -1 && {
        "aria-activedescendant": elementIds.getItemId(latestState.highlightedIndex)
      }, {
        onMouseLeave: callAllEventHandlers(onMouseLeave, menuHandleMouseLeave),
        onKeyDown: callAllEventHandlers(onKeyDown, menuHandleKeyDown),
        onBlur: callAllEventHandlers(onBlur, menuHandleBlur)
      }, rest);
    }, [dispatch, latest, menuKeyDownHandlers, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds, getItemNodeFromIndex]),
    getToggleButtonProps = useCallback(function (_temp3, _temp4) {
      var _extends3,
        _ref3 = _temp3 === void 0 ? {} : _temp3,
        onClick = _ref3.onClick,
        onKeyDown = _ref3.onKeyDown,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
        ref = _ref3.ref,
        rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$2),
        _ref4 = _temp4 === void 0 ? {} : _temp4,
        _ref4$suppressRefErro = _ref4.suppressRefError,
        suppressRefError = _ref4$suppressRefErro === void 0 ? !1 : _ref4$suppressRefErro,
        toggleButtonHandleClick = function () {
          dispatch({
            type: ToggleButtonClick$1
          });
        },
        toggleButtonHandleKeyDown = function (event) {
          var key = normalizeArrowKey(event);
          key && toggleButtonKeyDownHandlers[key] ? toggleButtonKeyDownHandlers[key](event) : isAcceptedCharacterKey(key) && dispatch({
            type: ToggleButtonKeyDownCharacter,
            key,
            getItemNodeFromIndex
          });
        },
        toggleProps = _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
          toggleButtonRef.current = toggleButtonNode;
        }), _extends3.id = elementIds.toggleButtonId, _extends3["aria-haspopup"] = "listbox", _extends3["aria-expanded"] = latest.current.state.isOpen, _extends3["aria-labelledby"] = elementIds.labelId + " " + elementIds.toggleButtonId, _extends3), rest);
      return rest.disabled || (toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick), toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown)), setGetterPropCallInfo("getToggleButtonProps", suppressRefError, refKey, toggleButtonRef), toggleProps;
    }, [dispatch, latest, toggleButtonKeyDownHandlers, setGetterPropCallInfo, elementIds, getItemNodeFromIndex]),
    getItemProps = useCallback(function (_temp5) {
      var _extends4,
        _ref5 = _temp5 === void 0 ? {} : _temp5,
        item = _ref5.item,
        index = _ref5.index,
        onMouseMove = _ref5.onMouseMove,
        onClick = _ref5.onClick,
        _ref5$refKey = _ref5.refKey,
        refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey,
        ref = _ref5.ref,
        rest = _objectWithoutPropertiesLoose(_ref5, _excluded3$1),
        _latest$current = latest.current,
        latestState = _latest$current.state,
        latestProps = _latest$current.props,
        itemHandleMouseMove = function () {
          index !== latestState.highlightedIndex && (shouldScrollRef.current = !1, dispatch({
            type: ItemMouseMove$1,
            index
          }));
        },
        itemHandleClick = function () {
          dispatch({
            type: ItemClick$1,
            index
          });
        },
        itemIndex = getItemIndex(index, item, latestProps.items);
      if (itemIndex < 0) throw new Error("Pass either item or item index in getItemProps!");
      var itemProps = _extends((_extends4 = {
        role: "option",
        "aria-selected": "" + (itemIndex === latestState.highlightedIndex),
        id: elementIds.getItemId(itemIndex)
      }, _extends4[refKey] = handleRefs(ref, function (itemNode) {
        itemNode && (itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode);
      }), _extends4), rest);
      return rest.disabled || (itemProps.onMouseMove = callAllEventHandlers(onMouseMove, itemHandleMouseMove), itemProps.onClick = callAllEventHandlers(onClick, itemHandleClick)), itemProps;
    }, [dispatch, latest, shouldScrollRef, elementIds]);
  return {
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getItemProps,
    toggleMenu,
    openMenu,
    closeMenu,
    setHighlightedIndex,
    selectItem,
    reset,
    setInputValue,
    highlightedIndex,
    isOpen,
    selectedItem,
    inputValue
  };
}
var InputKeyDownArrowDown = 0,
  InputKeyDownArrowUp = 1,
  InputKeyDownEscape = 2,
  InputKeyDownHome = 3,
  InputKeyDownEnd = 4,
  InputKeyDownEnter = 5,
  InputChange = 6,
  InputBlur = 7,
  MenuMouseLeave = 8,
  ItemMouseMove = 9,
  ItemClick = 10,
  ToggleButtonClick = 11,
  FunctionToggleMenu = 12,
  FunctionOpenMenu = 13,
  FunctionCloseMenu = 14,
  FunctionSetHighlightedIndex = 15,
  FunctionSelectItem = 16,
  FunctionSetInputValue = 17,
  FunctionReset$1 = 18,
  ControlledPropUpdatedSelectedItem = 19,
  stateChangeTypes$1 = Object.freeze({
    __proto__: null,
    InputKeyDownArrowDown,
    InputKeyDownArrowUp,
    InputKeyDownEscape,
    InputKeyDownHome,
    InputKeyDownEnd,
    InputKeyDownEnter,
    InputChange,
    InputBlur,
    MenuMouseLeave,
    ItemMouseMove,
    ItemClick,
    ToggleButtonClick,
    FunctionToggleMenu,
    FunctionOpenMenu,
    FunctionCloseMenu,
    FunctionSetHighlightedIndex,
    FunctionSelectItem,
    FunctionSetInputValue,
    FunctionReset: FunctionReset$1,
    ControlledPropUpdatedSelectedItem
  });
function getInitialState$1(props) {
  var initialState = getInitialState$2(props),
    selectedItem = initialState.selectedItem,
    inputValue = initialState.inputValue;
  return inputValue === "" && selectedItem && props.defaultInputValue === void 0 && props.initialInputValue === void 0 && props.inputValue === void 0 && (inputValue = props.itemToString(selectedItem)), _extends({}, initialState, {
    inputValue
  });
}
var propTypes$1 = {
  items: import_prop_types.default.array.isRequired,
  itemToString: import_prop_types.default.func,
  getA11yStatusMessage: import_prop_types.default.func,
  getA11ySelectionMessage: import_prop_types.default.func,
  circularNavigation: import_prop_types.default.bool,
  highlightedIndex: import_prop_types.default.number,
  defaultHighlightedIndex: import_prop_types.default.number,
  initialHighlightedIndex: import_prop_types.default.number,
  isOpen: import_prop_types.default.bool,
  defaultIsOpen: import_prop_types.default.bool,
  initialIsOpen: import_prop_types.default.bool,
  selectedItem: import_prop_types.default.any,
  initialSelectedItem: import_prop_types.default.any,
  defaultSelectedItem: import_prop_types.default.any,
  inputValue: import_prop_types.default.string,
  defaultInputValue: import_prop_types.default.string,
  initialInputValue: import_prop_types.default.string,
  id: import_prop_types.default.string,
  labelId: import_prop_types.default.string,
  menuId: import_prop_types.default.string,
  getItemId: import_prop_types.default.func,
  inputId: import_prop_types.default.string,
  toggleButtonId: import_prop_types.default.string,
  stateReducer: import_prop_types.default.func,
  onSelectedItemChange: import_prop_types.default.func,
  onHighlightedIndexChange: import_prop_types.default.func,
  onStateChange: import_prop_types.default.func,
  onIsOpenChange: import_prop_types.default.func,
  onInputValueChange: import_prop_types.default.func,
  environment: import_prop_types.default.shape({
    addEventListener: import_prop_types.default.func,
    removeEventListener: import_prop_types.default.func,
    document: import_prop_types.default.shape({
      getElementById: import_prop_types.default.func,
      activeElement: import_prop_types.default.any,
      body: import_prop_types.default.any
    })
  })
};
function useControlledReducer(reducer, initialState, props) {
  var previousSelectedItemRef = useRef(),
    _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
    state = _useEnhancedReducer[0],
    dispatch = _useEnhancedReducer[1];
  return useEffect(function () {
    isControlledProp(props, "selectedItem") && (previousSelectedItemRef.current !== props.selectedItem && dispatch({
      type: ControlledPropUpdatedSelectedItem,
      inputValue: props.itemToString(props.selectedItem)
    }), previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem);
  }), [getState(state, props), dispatch];
}
var validatePropTypes$1 = noop,
  defaultProps$1 = _extends({}, defaultProps$3, {
    getA11yStatusMessage: getA11yStatusMessage$1,
    circularNavigation: !0
  });
function downshiftUseComboboxReducer(state, action) {
  var type = action.type,
    props = action.props,
    shiftKey = action.shiftKey,
    changes;
  switch (type) {
    case ItemClick:
      changes = {
        isOpen: getDefaultValue$1(props, "isOpen"),
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex"),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;
    case InputKeyDownArrowDown:
      state.isOpen ? changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      } : changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
        isOpen: props.items.length >= 0
      };
      break;
    case InputKeyDownArrowUp:
      state.isOpen ? changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      } : changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
        isOpen: props.items.length >= 0
      };
      break;
    case InputKeyDownEnter:
      changes = _extends({}, state.isOpen && state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex],
        isOpen: getDefaultValue$1(props, "isOpen"),
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex"),
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;
    case InputKeyDownEscape:
      changes = _extends({
        isOpen: !1,
        highlightedIndex: -1
      }, !state.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, !1)
      };
      break;
    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, !1)
      };
      break;
    case InputBlur:
      changes = _extends({
        isOpen: !1,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && action.selectItem && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;
    case InputChange:
      changes = {
        isOpen: !0,
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex"),
        inputValue: action.inputValue
      };
      break;
    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem,
        inputValue: props.itemToString(action.selectedItem)
      };
      break;
    case ControlledPropUpdatedSelectedItem:
      changes = {
        inputValue: action.inputValue
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$1);
  }
  return _extends({}, state, changes);
}
var _excluded$1 = ["onMouseLeave", "refKey", "ref"],
  _excluded2$1 = ["item", "index", "refKey", "ref", "onMouseMove", "onClick", "onPress"],
  _excluded3 = ["onClick", "onPress", "refKey", "ref"],
  _excluded4 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "refKey", "ref"],
  _excluded5 = ["refKey", "ref"];
useCombobox.stateChangeTypes = stateChangeTypes$1;
function useCombobox(userProps) {
  userProps === void 0 && (userProps = {}), validatePropTypes$1(userProps, useCombobox);
  var props = _extends({}, defaultProps$1, userProps),
    initialIsOpen = props.initialIsOpen,
    defaultIsOpen = props.defaultIsOpen,
    items = props.items,
    scrollIntoView2 = props.scrollIntoView,
    environment = props.environment,
    getA11yStatusMessage2 = props.getA11yStatusMessage,
    getA11ySelectionMessage2 = props.getA11ySelectionMessage,
    itemToString2 = props.itemToString,
    initialState = getInitialState$1(props),
    _useControlledReducer = useControlledReducer(downshiftUseComboboxReducer, initialState, props),
    state = _useControlledReducer[0],
    dispatch = _useControlledReducer[1],
    isOpen = state.isOpen,
    highlightedIndex = state.highlightedIndex,
    selectedItem = state.selectedItem,
    inputValue = state.inputValue,
    menuRef = useRef(null),
    itemRefs = useRef({}),
    inputRef = useRef(null),
    toggleButtonRef = useRef(null),
    comboboxRef = useRef(null),
    isInitialMountRef = useRef(!0),
    elementIds = useElementIds(props),
    previousResultCountRef = useRef(),
    latest = useLatestRef({
      state,
      props
    }),
    getItemNodeFromIndex = useCallback(function (index) {
      return itemRefs.current[elementIds.getItemId(index)];
    }, [elementIds]);
  useA11yMessageSetter(getA11yStatusMessage2, [isOpen, highlightedIndex, inputValue, items], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state)), useA11yMessageSetter(getA11ySelectionMessage2, [selectedItem], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex,
    isOpen,
    itemRefs,
    scrollIntoView: scrollIntoView2,
    getItemNodeFromIndex
  });
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props,
    state
  }), useEffect(function () {
    var focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;
    focusOnOpen && inputRef.current && inputRef.current.focus();
  }, []), useEffect(function () {
    isInitialMountRef.current || (previousResultCountRef.current = items.length);
  });
  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [comboboxRef, menuRef, toggleButtonRef], environment, function () {
      dispatch({
        type: InputBlur,
        selectItem: !1
      });
    }),
    setGetterPropCallInfo = useGetterPropsCalledChecker("getInputProps", "getComboboxProps", "getMenuProps");
  useEffect(function () {
    isInitialMountRef.current = !1;
  }, []), useEffect(function () {
    isOpen || (itemRefs.current = {});
  }, [isOpen]);
  var inputKeyDownHandlers = useMemo(function () {
      return {
        ArrowDown: function (event) {
          event.preventDefault(), dispatch({
            type: InputKeyDownArrowDown,
            shiftKey: event.shiftKey,
            getItemNodeFromIndex
          });
        },
        ArrowUp: function (event) {
          event.preventDefault(), dispatch({
            type: InputKeyDownArrowUp,
            shiftKey: event.shiftKey,
            getItemNodeFromIndex
          });
        },
        Home: function (event) {
          !latest.current.state.isOpen || (event.preventDefault(), dispatch({
            type: InputKeyDownHome,
            getItemNodeFromIndex
          }));
        },
        End: function (event) {
          !latest.current.state.isOpen || (event.preventDefault(), dispatch({
            type: InputKeyDownEnd,
            getItemNodeFromIndex
          }));
        },
        Escape: function () {
          var latestState = latest.current.state;
          (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) && dispatch({
            type: InputKeyDownEscape
          });
        },
        Enter: function (event) {
          var latestState = latest.current.state;
          !latestState.isOpen || latestState.highlightedIndex < 0 || event.which === 229 || (event.preventDefault(), dispatch({
            type: InputKeyDownEnter,
            getItemNodeFromIndex
          }));
        }
      };
    }, [dispatch, latest, getItemNodeFromIndex]),
    getLabelProps = useCallback(function (labelProps) {
      return _extends({
        id: elementIds.labelId,
        htmlFor: elementIds.inputId
      }, labelProps);
    }, [elementIds]),
    getMenuProps = useCallback(function (_temp, _temp2) {
      var _extends2,
        _ref = _temp === void 0 ? {} : _temp,
        onMouseLeave = _ref.onMouseLeave,
        _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey,
        ref = _ref.ref,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded$1),
        _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$suppressRefErro = _ref2.suppressRefError,
        suppressRefError = _ref2$suppressRefErro === void 0 ? !1 : _ref2$suppressRefErro;
      return setGetterPropCallInfo("getMenuProps", suppressRefError, refKey, menuRef), _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
        menuRef.current = menuNode;
      }), _extends2.id = elementIds.menuId, _extends2.role = "listbox", _extends2["aria-labelledby"] = elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, function () {
        dispatch({
          type: MenuMouseLeave
        });
      }), _extends2), rest);
    }, [dispatch, setGetterPropCallInfo, elementIds]),
    getItemProps = useCallback(function (_temp3) {
      var _extends3,
        _ref4,
        _ref3 = _temp3 === void 0 ? {} : _temp3,
        item = _ref3.item,
        index = _ref3.index,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
        ref = _ref3.ref,
        onMouseMove = _ref3.onMouseMove,
        onClick = _ref3.onClick;
      _ref3.onPress;
      var rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$1),
        _latest$current = latest.current,
        latestProps = _latest$current.props,
        latestState = _latest$current.state,
        itemIndex = getItemIndex(index, item, latestProps.items);
      if (itemIndex < 0) throw new Error("Pass either item or item index in getItemProps!");
      var onSelectKey = "onClick",
        customClickHandler = onClick,
        itemHandleMouseMove = function () {
          index !== latestState.highlightedIndex && (shouldScrollRef.current = !1, dispatch({
            type: ItemMouseMove,
            index
          }));
        },
        itemHandleClick = function () {
          dispatch({
            type: ItemClick,
            index
          }), inputRef.current && inputRef.current.focus();
        };
      return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (itemNode) {
        itemNode && (itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode);
      }), _extends3.role = "option", _extends3["aria-selected"] = "" + (itemIndex === latestState.highlightedIndex), _extends3.id = elementIds.getItemId(itemIndex), _extends3), !rest.disabled && (_ref4 = {
        onMouseMove: callAllEventHandlers(onMouseMove, itemHandleMouseMove)
      }, _ref4[onSelectKey] = callAllEventHandlers(customClickHandler, itemHandleClick), _ref4), rest);
    }, [dispatch, latest, shouldScrollRef, elementIds]),
    getToggleButtonProps = useCallback(function (_temp4) {
      var _extends4,
        _ref5 = _temp4 === void 0 ? {} : _temp4,
        onClick = _ref5.onClick;
      _ref5.onPress;
      var _ref5$refKey = _ref5.refKey,
        refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey,
        ref = _ref5.ref,
        rest = _objectWithoutPropertiesLoose(_ref5, _excluded3),
        toggleButtonHandleClick = function () {
          dispatch({
            type: ToggleButtonClick
          }), !latest.current.state.isOpen && inputRef.current && inputRef.current.focus();
        };
      return _extends((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (toggleButtonNode) {
        toggleButtonRef.current = toggleButtonNode;
      }), _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && _extends({}, {
        onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
      }), rest);
    }, [dispatch, latest, elementIds]),
    getInputProps = useCallback(function (_temp5, _temp6) {
      var _extends5,
        _ref6 = _temp5 === void 0 ? {} : _temp5,
        onKeyDown = _ref6.onKeyDown,
        onChange = _ref6.onChange,
        onInput = _ref6.onInput,
        onBlur = _ref6.onBlur;
      _ref6.onChangeText;
      var _ref6$refKey = _ref6.refKey,
        refKey = _ref6$refKey === void 0 ? "ref" : _ref6$refKey,
        ref = _ref6.ref,
        rest = _objectWithoutPropertiesLoose(_ref6, _excluded4),
        _ref7 = _temp6 === void 0 ? {} : _temp6,
        _ref7$suppressRefErro = _ref7.suppressRefError,
        suppressRefError = _ref7$suppressRefErro === void 0 ? !1 : _ref7$suppressRefErro;
      setGetterPropCallInfo("getInputProps", suppressRefError, refKey, inputRef);
      var latestState = latest.current.state,
        inputHandleKeyDown = function (event) {
          var key = normalizeArrowKey(event);
          key && inputKeyDownHandlers[key] && inputKeyDownHandlers[key](event);
        },
        inputHandleChange = function (event) {
          dispatch({
            type: InputChange,
            inputValue: event.target.value
          });
        },
        inputHandleBlur = function () {
          latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown && dispatch({
            type: InputBlur,
            selectItem: !0
          });
        },
        onChangeKey = "onChange",
        eventHandlers = {};
      if (!rest.disabled) {
        var _eventHandlers;
        eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers);
      }
      return _extends((_extends5 = {}, _extends5[refKey] = handleRefs(ref, function (inputNode) {
        inputRef.current = inputNode;
      }), _extends5.id = elementIds.inputId, _extends5["aria-autocomplete"] = "list", _extends5["aria-controls"] = elementIds.menuId, _extends5), latestState.isOpen && latestState.highlightedIndex > -1 && {
        "aria-activedescendant": elementIds.getItemId(latestState.highlightedIndex)
      }, {
        "aria-labelledby": elementIds.labelId,
        autoComplete: "off",
        value: latestState.inputValue
      }, eventHandlers, rest);
    }, [dispatch, inputKeyDownHandlers, latest, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds]),
    getComboboxProps = useCallback(function (_temp7, _temp8) {
      var _extends6,
        _ref8 = _temp7 === void 0 ? {} : _temp7,
        _ref8$refKey = _ref8.refKey,
        refKey = _ref8$refKey === void 0 ? "ref" : _ref8$refKey,
        ref = _ref8.ref,
        rest = _objectWithoutPropertiesLoose(_ref8, _excluded5),
        _ref9 = _temp8 === void 0 ? {} : _temp8,
        _ref9$suppressRefErro = _ref9.suppressRefError,
        suppressRefError = _ref9$suppressRefErro === void 0 ? !1 : _ref9$suppressRefErro;
      return setGetterPropCallInfo("getComboboxProps", suppressRefError, refKey, comboboxRef), _extends((_extends6 = {}, _extends6[refKey] = handleRefs(ref, function (comboboxNode) {
        comboboxRef.current = comboboxNode;
      }), _extends6.role = "combobox", _extends6["aria-haspopup"] = "listbox", _extends6["aria-owns"] = elementIds.menuId, _extends6["aria-expanded"] = latest.current.state.isOpen, _extends6), rest);
    }, [latest, setGetterPropCallInfo, elementIds]),
    toggleMenu = useCallback(function () {
      dispatch({
        type: FunctionToggleMenu
      });
    }, [dispatch]),
    closeMenu = useCallback(function () {
      dispatch({
        type: FunctionCloseMenu
      });
    }, [dispatch]),
    openMenu = useCallback(function () {
      dispatch({
        type: FunctionOpenMenu
      });
    }, [dispatch]),
    setHighlightedIndex = useCallback(function (newHighlightedIndex) {
      dispatch({
        type: FunctionSetHighlightedIndex,
        highlightedIndex: newHighlightedIndex
      });
    }, [dispatch]),
    selectItem = useCallback(function (newSelectedItem) {
      dispatch({
        type: FunctionSelectItem,
        selectedItem: newSelectedItem
      });
    }, [dispatch]),
    setInputValue = useCallback(function (newInputValue) {
      dispatch({
        type: FunctionSetInputValue,
        inputValue: newInputValue
      });
    }, [dispatch]),
    reset = useCallback(function () {
      dispatch({
        type: FunctionReset$1
      });
    }, [dispatch]);
  return {
    getItemProps,
    getLabelProps,
    getMenuProps,
    getInputProps,
    getComboboxProps,
    getToggleButtonProps,
    toggleMenu,
    openMenu,
    closeMenu,
    setHighlightedIndex,
    setInputValue,
    selectItem,
    reset,
    highlightedIndex,
    isOpen,
    selectedItem,
    inputValue
  };
}
var defaultStateValues = {
  activeIndex: -1,
  selectedItems: []
};
function getInitialValue(props, propKey) {
  return getInitialValue$1(props, propKey, defaultStateValues);
}
function getDefaultValue(props, propKey) {
  return getDefaultValue$1(props, propKey, defaultStateValues);
}
function getInitialState(props) {
  var activeIndex = getInitialValue(props, "activeIndex"),
    selectedItems = getInitialValue(props, "selectedItems");
  return {
    activeIndex,
    selectedItems
  };
}
function isKeyDownOperationPermitted(event) {
  if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return !1;
  var element = event.target;
  return !(element instanceof HTMLInputElement && element.value !== "" && (element.selectionStart !== 0 || element.selectionEnd !== 0));
}
function getA11yRemovalMessage(selectionParameters) {
  var removedSelectedItem = selectionParameters.removedSelectedItem,
    itemToStringLocal = selectionParameters.itemToString;
  return itemToStringLocal(removedSelectedItem) + " has been removed.";
}
var propTypes = {
    selectedItems: import_prop_types.default.array,
    initialSelectedItems: import_prop_types.default.array,
    defaultSelectedItems: import_prop_types.default.array,
    itemToString: import_prop_types.default.func,
    getA11yRemovalMessage: import_prop_types.default.func,
    stateReducer: import_prop_types.default.func,
    activeIndex: import_prop_types.default.number,
    initialActiveIndex: import_prop_types.default.number,
    defaultActiveIndex: import_prop_types.default.number,
    onActiveIndexChange: import_prop_types.default.func,
    onSelectedItemsChange: import_prop_types.default.func,
    keyNavigationNext: import_prop_types.default.string,
    keyNavigationPrevious: import_prop_types.default.string,
    environment: import_prop_types.default.shape({
      addEventListener: import_prop_types.default.func,
      removeEventListener: import_prop_types.default.func,
      document: import_prop_types.default.shape({
        getElementById: import_prop_types.default.func,
        activeElement: import_prop_types.default.any,
        body: import_prop_types.default.any
      })
    })
  },
  defaultProps = {
    itemToString: defaultProps$3.itemToString,
    stateReducer: defaultProps$3.stateReducer,
    environment: defaultProps$3.environment,
    getA11yRemovalMessage,
    keyNavigationNext: "ArrowRight",
    keyNavigationPrevious: "ArrowLeft"
  },
  validatePropTypes = noop,
  SelectedItemClick = 0,
  SelectedItemKeyDownDelete = 1,
  SelectedItemKeyDownBackspace = 2,
  SelectedItemKeyDownNavigationNext = 3,
  SelectedItemKeyDownNavigationPrevious = 4,
  DropdownKeyDownNavigationPrevious = 5,
  DropdownKeyDownBackspace = 6,
  DropdownClick = 7,
  FunctionAddSelectedItem = 8,
  FunctionRemoveSelectedItem = 9,
  FunctionSetSelectedItems = 10,
  FunctionSetActiveIndex = 11,
  FunctionReset = 12,
  stateChangeTypes = Object.freeze({
    __proto__: null,
    SelectedItemClick,
    SelectedItemKeyDownDelete,
    SelectedItemKeyDownBackspace,
    SelectedItemKeyDownNavigationNext,
    SelectedItemKeyDownNavigationPrevious,
    DropdownKeyDownNavigationPrevious,
    DropdownKeyDownBackspace,
    DropdownClick,
    FunctionAddSelectedItem,
    FunctionRemoveSelectedItem,
    FunctionSetSelectedItems,
    FunctionSetActiveIndex,
    FunctionReset
  });
function downshiftMultipleSelectionReducer(state, action) {
  var type = action.type,
    index = action.index,
    props = action.props,
    selectedItem = action.selectedItem,
    activeIndex = state.activeIndex,
    selectedItems = state.selectedItems,
    changes;
  switch (type) {
    case SelectedItemClick:
      changes = {
        activeIndex: index
      };
      break;
    case SelectedItemKeyDownNavigationPrevious:
      changes = {
        activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
      };
      break;
    case SelectedItemKeyDownNavigationNext:
      changes = {
        activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
      };
      break;
    case SelectedItemKeyDownBackspace:
    case SelectedItemKeyDownDelete:
      {
        var newActiveIndex = activeIndex;
        selectedItems.length === 1 ? newActiveIndex = -1 : activeIndex === selectedItems.length - 1 && (newActiveIndex = selectedItems.length - 2), changes = _extends({
          selectedItems: [].concat(selectedItems.slice(0, activeIndex), selectedItems.slice(activeIndex + 1))
        }, {
          activeIndex: newActiveIndex
        });
        break;
      }
    case DropdownKeyDownNavigationPrevious:
      changes = {
        activeIndex: selectedItems.length - 1
      };
      break;
    case DropdownKeyDownBackspace:
      changes = {
        selectedItems: selectedItems.slice(0, selectedItems.length - 1)
      };
      break;
    case FunctionAddSelectedItem:
      changes = {
        selectedItems: [].concat(selectedItems, [selectedItem])
      };
      break;
    case DropdownClick:
      changes = {
        activeIndex: -1
      };
      break;
    case FunctionRemoveSelectedItem:
      {
        var _newActiveIndex = activeIndex,
          selectedItemIndex = selectedItems.indexOf(selectedItem);
        selectedItems.length === 1 ? _newActiveIndex = -1 : selectedItemIndex === selectedItems.length - 1 && (_newActiveIndex = selectedItems.length - 2), changes = _extends({
          selectedItems: [].concat(selectedItems.slice(0, selectedItemIndex), selectedItems.slice(selectedItemIndex + 1))
        }, {
          activeIndex: _newActiveIndex
        });
        break;
      }
    case FunctionSetSelectedItems:
      {
        var newSelectedItems = action.selectedItems;
        changes = {
          selectedItems: newSelectedItems
        };
        break;
      }
    case FunctionSetActiveIndex:
      {
        var _newActiveIndex2 = action.activeIndex;
        changes = {
          activeIndex: _newActiveIndex2
        };
        break;
      }
    case FunctionReset:
      changes = {
        activeIndex: getDefaultValue(props, "activeIndex"),
        selectedItems: getDefaultValue(props, "selectedItems")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return _extends({}, state, changes);
}
var _excluded = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"],
  _excluded2 = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
useMultipleSelection.stateChangeTypes = stateChangeTypes;
function useMultipleSelection(userProps) {
  userProps === void 0 && (userProps = {}), validatePropTypes(userProps, useMultipleSelection);
  var props = _extends({}, defaultProps, userProps),
    getA11yRemovalMessage2 = props.getA11yRemovalMessage,
    itemToString2 = props.itemToString,
    environment = props.environment,
    keyNavigationNext = props.keyNavigationNext,
    keyNavigationPrevious = props.keyNavigationPrevious,
    _useControlledReducer = useControlledReducer$1(downshiftMultipleSelectionReducer, getInitialState(props), props),
    state = _useControlledReducer[0],
    dispatch = _useControlledReducer[1],
    activeIndex = state.activeIndex,
    selectedItems = state.selectedItems,
    isInitialMountRef = useRef(!0),
    dropdownRef = useRef(null),
    previousSelectedItemsRef = useRef(selectedItems),
    selectedItemRefs = useRef();
  selectedItemRefs.current = [];
  var latest = useLatestRef({
    state,
    props
  });
  useEffect(function () {
    if (!isInitialMountRef.current) {
      if (selectedItems.length < previousSelectedItemsRef.current.length) {
        var removedSelectedItem = previousSelectedItemsRef.current.find(function (item) {
          return selectedItems.indexOf(item) < 0;
        });
        setStatus(getA11yRemovalMessage2({
          itemToString: itemToString2,
          resultCount: selectedItems.length,
          removedSelectedItem,
          activeIndex,
          activeSelectedItem: selectedItems[activeIndex]
        }), environment.document);
      }
      previousSelectedItemsRef.current = selectedItems;
    }
  }, [selectedItems.length]), useEffect(function () {
    isInitialMountRef.current || (activeIndex === -1 && dropdownRef.current ? dropdownRef.current.focus() : selectedItemRefs.current[activeIndex] && selectedItemRefs.current[activeIndex].focus());
  }, [activeIndex]), useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props,
    state
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker("getDropdownProps");
  useEffect(function () {
    isInitialMountRef.current = !1;
  }, []);
  var selectedItemKeyDownHandlers = useMemo(function () {
      var _ref;
      return _ref = {}, _ref[keyNavigationPrevious] = function () {
        dispatch({
          type: SelectedItemKeyDownNavigationPrevious
        });
      }, _ref[keyNavigationNext] = function () {
        dispatch({
          type: SelectedItemKeyDownNavigationNext
        });
      }, _ref.Delete = function () {
        dispatch({
          type: SelectedItemKeyDownDelete
        });
      }, _ref.Backspace = function () {
        dispatch({
          type: SelectedItemKeyDownBackspace
        });
      }, _ref;
    }, [dispatch, keyNavigationNext, keyNavigationPrevious]),
    dropdownKeyDownHandlers = useMemo(function () {
      var _ref2;
      return _ref2 = {}, _ref2[keyNavigationPrevious] = function (event) {
        isKeyDownOperationPermitted(event) && dispatch({
          type: DropdownKeyDownNavigationPrevious
        });
      }, _ref2.Backspace = function (event) {
        isKeyDownOperationPermitted(event) && dispatch({
          type: DropdownKeyDownBackspace
        });
      }, _ref2;
    }, [dispatch, keyNavigationPrevious]),
    getSelectedItemProps = useCallback(function (_temp) {
      var _extends2,
        _ref3 = _temp === void 0 ? {} : _temp,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
        ref = _ref3.ref,
        onClick = _ref3.onClick,
        onKeyDown = _ref3.onKeyDown,
        selectedItem = _ref3.selectedItem,
        index = _ref3.index,
        rest = _objectWithoutPropertiesLoose(_ref3, _excluded),
        latestState = latest.current.state,
        itemIndex = getItemIndex(index, selectedItem, latestState.selectedItems);
      if (itemIndex < 0) throw new Error("Pass either selectedItem or index in getSelectedItemProps!");
      var selectedItemHandleClick = function () {
          dispatch({
            type: SelectedItemClick,
            index
          });
        },
        selectedItemHandleKeyDown = function (event) {
          var key = normalizeArrowKey(event);
          key && selectedItemKeyDownHandlers[key] && selectedItemKeyDownHandlers[key](event);
        };
      return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (selectedItemNode) {
        selectedItemNode && selectedItemRefs.current.push(selectedItemNode);
      }), _extends2.tabIndex = index === latestState.activeIndex ? 0 : -1, _extends2.onClick = callAllEventHandlers(onClick, selectedItemHandleClick), _extends2.onKeyDown = callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown), _extends2), rest);
    }, [dispatch, latest, selectedItemKeyDownHandlers]),
    getDropdownProps = useCallback(function (_temp2, _temp3) {
      var _extends3,
        _ref4 = _temp2 === void 0 ? {} : _temp2,
        _ref4$refKey = _ref4.refKey,
        refKey = _ref4$refKey === void 0 ? "ref" : _ref4$refKey,
        ref = _ref4.ref,
        onKeyDown = _ref4.onKeyDown,
        onClick = _ref4.onClick,
        _ref4$preventKeyActio = _ref4.preventKeyAction,
        preventKeyAction = _ref4$preventKeyActio === void 0 ? !1 : _ref4$preventKeyActio,
        rest = _objectWithoutPropertiesLoose(_ref4, _excluded2),
        _ref5 = _temp3 === void 0 ? {} : _temp3,
        _ref5$suppressRefErro = _ref5.suppressRefError,
        suppressRefError = _ref5$suppressRefErro === void 0 ? !1 : _ref5$suppressRefErro;
      setGetterPropCallInfo("getDropdownProps", suppressRefError, refKey, dropdownRef);
      var dropdownHandleKeyDown = function (event) {
          var key = normalizeArrowKey(event);
          key && dropdownKeyDownHandlers[key] && dropdownKeyDownHandlers[key](event);
        },
        dropdownHandleClick = function () {
          dispatch({
            type: DropdownClick
          });
        };
      return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (dropdownNode) {
        dropdownNode && (dropdownRef.current = dropdownNode);
      }), _extends3), !preventKeyAction && {
        onKeyDown: callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
        onClick: callAllEventHandlers(onClick, dropdownHandleClick)
      }, rest);
    }, [dispatch, dropdownKeyDownHandlers, setGetterPropCallInfo]),
    addSelectedItem = useCallback(function (selectedItem) {
      dispatch({
        type: FunctionAddSelectedItem,
        selectedItem
      });
    }, [dispatch]),
    removeSelectedItem = useCallback(function (selectedItem) {
      dispatch({
        type: FunctionRemoveSelectedItem,
        selectedItem
      });
    }, [dispatch]),
    setSelectedItems = useCallback(function (newSelectedItems) {
      dispatch({
        type: FunctionSetSelectedItems,
        selectedItems: newSelectedItems
      });
    }, [dispatch]),
    setActiveIndex = useCallback(function (newActiveIndex) {
      dispatch({
        type: FunctionSetActiveIndex,
        activeIndex: newActiveIndex
      });
    }, [dispatch]),
    reset = useCallback(function () {
      dispatch({
        type: FunctionReset
      });
    }, [dispatch]);
  return {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    setSelectedItems,
    setActiveIndex,
    reset,
    selectedItems,
    activeIndex
  };
}
var src_default = Downshift$1;
export { src_default as default, resetIdCounter, useCombobox, useMultipleSelection, useSelect };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */